export const provinceComuniMap: Map<string, string[]> = new Map([
    ["PR", [
        "Albareto",
        "Bardi",
        "Bedonia",
        "Berceto",
        "Bore",
        "Borgo Val di Taro",
        "Busseto",
        "Calestano",
        "Collecchio",
        "Colorno",
        "Compiano",
        "Corniglio",
        "Felino",
        "Fidenza",
        "Fontanellato",
        "Fontevivo",
        "Fornovo di Taro",
        "Langhirano",
        "Lesignano de\u0027 Bagni",
        "Medesano",
        "Monchio delle Corti",
        "Montechiarugolo",
        "Neviano degli Arduini",
        "Noceto",
        "Palanzano",
        "Parma",
        "Pellegrino Parmense",
        "Roccabianca",
        "Sala Baganza",
        "Salsomaggiore Terme",
        "San Secondo Parmense",
        "Solignano",
        "Soragna",
        "Terenzo",
        "Tizzano Val Parma",
        "Tornolo",
        "Torrile",
        "Traversetolo",
        "Valmozzola",
        "Varano de\u0027 Melegari",
        "Varsi",
        "Sissa Trecasali",
        "Polesine Zibello",
        "Sorbolo Mezzani"
    ]],
    ["PT", [
        "Agliana",
        "Buggiano",
        "Lamporecchio",
        "Larciano",
        "Marliana",
        "Massa e Cozzile",
        "Monsummano Terme",
        "Montale",
        "Montecatini-Terme",
        "Pescia",
        "Pieve a Nievole",
        "Pistoia",
        "Ponte Buggianese",
        "Quarrata",
        "Sambuca Pistoiese",
        "Serravalle Pistoiese",
        "Uzzano",
        "Chiesina Uzzanese",
        "Abetone Cutigliano",
        "San Marcello Piteglio"
    ]],
    ["PU", [
        "Acqualagna",
        "Apecchio",
        "Belforte all\u0027Isauro",
        "Borgo Pace",
        "Cagli",
        "Cantiano",
        "Carpegna",
        "Cartoceto",
        "Fano",
        "Fermignano",
        "Fossombrone",
        "Fratte Rosa",
        "Frontino",
        "Frontone",
        "Gabicce Mare",
        "Gradara",
        "Isola del Piano",
        "Lunano",
        "Macerata Feltria",
        "Mercatello sul Metauro",
        "Mercatino Conca",
        "Mombaroccio",
        "Mondavio",
        "Mondolfo",
        "Montecalvo in Foglia",
        "Monte Cerignone",
        "Montefelcino",
        "Monte Grimano Terme",
        "Montelabbate",
        "Monte Porzio",
        "Peglio",
        "Pergola",
        "Pesaro",
        "Petriano",
        "Piandimeleto",
        "Pietrarubbia",
        "Piobbico",
        "San Costanzo",
        "San Lorenzo in Campo",
        "Sant\u0027Angelo in Vado",
        "Sant\u0027Ippolito",
        "Serra Sant\u0027Abbondio",
        "Tavoleto",
        "Tavullia",
        "Urbania",
        "Urbino",
        "Vallefoglia",
        "Colli al Metauro",
        "Terre Roveresche",
        "Sassocorvaro Auditore"
    ]],
    ["PV", [
        "Alagna",
        "Albonese",
        "Albuzzano",
        "Arena Po",
        "Badia Pavese",
        "Bagnaria",
        "Barbianello",
        "Bascapè",
        "Bastida Pancarana",
        "Battuda",
        "Belgioioso",
        "Bereguardo",
        "Borgarello",
        "Borgo Priolo",
        "Borgoratto Mormorolo",
        "Borgo San Siro",
        "Bornasco",
        "Bosnasco",
        "Brallo di Pregola",
        "Breme",
        "Bressana Bottarone",
        "Broni",
        "Calvignano",
        "Campospinoso Albaredo",
        "Candia Lomellina",
        "Canneto Pavese",
        "Carbonara al Ticino",
        "Casanova Lonati",
        "Casatisma",
        "Casei Gerola",
        "Casorate Primo",
        "Cassolnovo",
        "Castana",
        "Casteggio",
        "Castelletto di Branduzzo",
        "Castello d\u0027Agogna",
        "Castelnovetto",
        "Cava Manara",
        "Cecima",
        "Ceranova",
        "Ceretto Lomellina",
        "Cergnago",
        "Certosa di Pavia",
        "Cervesina",
        "Chignolo Po",
        "Cigognola",
        "Cilavegna",
        "Codevilla",
        "Confienza",
        "Copiano",
        "Corana",
        "Corvino San Quirico",
        "Costa de\u0027 Nobili",
        "Cozzo",
        "Cura Carpignano",
        "Dorno",
        "Ferrera Erbognone",
        "Filighera",
        "Fortunago",
        "Frascarolo",
        "Galliavola",
        "Gambarana",
        "Gambolò",
        "Garlasco",
        "Gerenzago",
        "Giussago",
        "Godiasco Salice Terme",
        "Golferenzo",
        "Gravellona Lomellina",
        "Gropello Cairoli",
        "Inverno e Monteleone",
        "Landriano",
        "Langosco",
        "Lardirago",
        "Linarolo",
        "Lirio",
        "Lomello",
        "Lungavilla",
        "Magherno",
        "Marcignago",
        "Marzano",
        "Mede",
        "Menconico",
        "Mezzana Bigli",
        "Mezzana Rabattone",
        "Mezzanino",
        "Miradolo Terme",
        "Montalto Pavese",
        "Montebello della Battaglia",
        "Montecalvo Versiggia",
        "Montescano",
        "Montesegale",
        "Monticelli Pavese",
        "Montù Beccaria",
        "Mornico Losana",
        "Mortara",
        "Nicorvo",
        "Olevano di Lomellina",
        "Oliva Gessi",
        "Ottobiano",
        "Palestro",
        "Pancarana",
        "Parona",
        "Pavia",
        "Pietra de\u0027 Giorgi",
        "Pieve Albignola",
        "Pieve del Cairo",
        "Pieve Porto Morone",
        "Pinarolo Po",
        "Pizzale",
        "Ponte Nizza",
        "Portalbera",
        "Rea",
        "Redavalle",
        "Retorbido",
        "Rivanazzano Terme",
        "Robbio",
        "Robecco Pavese",
        "Rocca de\u0027 Giorgi",
        "Rocca Susella",
        "Rognano",
        "Romagnese",
        "Roncaro",
        "Rosasco",
        "Rovescala",
        "San Cipriano Po",
        "San Damiano al Colle",
        "San Genesio ed Uniti",
        "San Giorgio di Lomellina",
        "San Martino Siccomario",
        "Sannazzaro de\u0027 Burgondi",
        "Santa Cristina e Bissone",
        "Santa Giuletta",
        "Sant\u0027Alessio con Vialone",
        "Santa Margherita di Staffora",
        "Santa Maria della Versa",
        "Sant\u0027Angelo Lomellina",
        "San Zenone al Po",
        "Sartirana Lomellina",
        "Scaldasole",
        "Semiana",
        "Silvano Pietra",
        "Siziano",
        "Sommo",
        "Spessa",
        "Stradella",
        "Suardi",
        "Torrazza Coste",
        "Torre Beretti e Castellaro",
        "Torre d\u0027Arese",
        "Torre de\u0027 Negri",
        "Torre d\u0027Isola",
        "Torrevecchia Pia",
        "Torricella Verzate",
        "Travacò Siccomario",
        "Trivolzio",
        "Tromello",
        "Trovo",
        "Val di Nizza",
        "Valeggio",
        "Valle Lomellina",
        "Valle Salimbene",
        "Varzi",
        "Velezzo Lomellina",
        "Vellezzo Bellini",
        "Verretto",
        "Verrua Po",
        "Vidigulfo",
        "Vigevano",
        "Villa Biscossi",
        "Villanova d\u0027Ardenghi",
        "Villanterio",
        "Vistarino",
        "Voghera",
        "Volpara",
        "Zavattarello",
        "Zeccone",
        "Zeme",
        "Zenevredo",
        "Zerbo",
        "Zerbolò",
        "Zinasco",
        "Cornale e Bastida",
        "Corteolona e Genzone",
        "Colli Verdi"
    ]],
    ["PZ", [
        "Abriola",
        "Acerenza",
        "Albano di Lucania",
        "Anzi",
        "Armento",
        "Atella",
        "Avigliano",
        "Balvano",
        "Banzi",
        "Baragiano",
        "Barile",
        "Bella",
        "Brienza",
        "Brindisi Montagna",
        "Calvello",
        "Calvera",
        "Campomaggiore",
        "Cancellara",
        "Carbone",
        "San Paolo Albanese",
        "Castelgrande",
        "Castelluccio Inferiore",
        "Castelluccio Superiore",
        "Castelmezzano",
        "Castelsaraceno",
        "Castronuovo di Sant\u0027Andrea",
        "Cersosimo",
        "Chiaromonte",
        "Corleto Perticara",
        "Episcopia",
        "Fardella",
        "Filiano",
        "Forenza",
        "Francavilla in Sinni",
        "Gallicchio",
        "Genzano di Lucania",
        "Grumento Nova",
        "Guardia Perticara",
        "Lagonegro",
        "Latronico",
        "Laurenzana",
        "Lauria",
        "Lavello",
        "Maratea",
        "Marsico Nuovo",
        "Marsicovetere",
        "Maschito",
        "Melfi",
        "Missanello",
        "Moliterno",
        "Montemilone",
        "Montemurro",
        "Muro Lucano",
        "Nemoli",
        "Noepoli",
        "Oppido Lucano",
        "Palazzo San Gervasio",
        "Pescopagano",
        "Picerno",
        "Pietragalla",
        "Pietrapertosa",
        "Pignola",
        "Potenza",
        "Rapolla",
        "Rapone",
        "Rionero in Vulture",
        "Ripacandida",
        "Rivello",
        "Roccanova",
        "Rotonda",
        "Ruoti",
        "Ruvo del Monte",
        "San Chirico Nuovo",
        "San Chirico Raparo",
        "San Costantino Albanese",
        "San Fele",
        "San Martino d\u0027Agri",
        "San Severino Lucano",
        "Sant\u0027Angelo Le Fratte",
        "Sant\u0027Arcangelo",
        "Sarconi",
        "Sasso di Castalda",
        "Satriano di Lucania",
        "Savoia di Lucania",
        "Senise",
        "Spinoso",
        "Teana",
        "Terranova di Pollino",
        "Tito",
        "Tolve",
        "Tramutola",
        "Trecchina",
        "Trivigno",
        "Vaglio Basilicata",
        "Venosa",
        "Vietri di Potenza",
        "Viggianello",
        "Viggiano",
        "Ginestra",
        "Paterno"
    ]],
    ["IM", [
        "Airole",
        "Apricale",
        "Aquila d\u0027Arroscia",
        "Armo",
        "Aurigo",
        "Badalucco",
        "Bajardo",
        "Bordighera",
        "Borghetto d\u0027Arroscia",
        "Borgomaro",
        "Camporosso",
        "Caravonica",
        "Castellaro",
        "Castel Vittorio",
        "Ceriana",
        "Cervo",
        "Cesio",
        "Chiusanico",
        "Chiusavecchia",
        "Cipressa",
        "Civezza",
        "Cosio d\u0027Arroscia",
        "Costarainera",
        "Diano Arentino",
        "Diano Castello",
        "Diano Marina",
        "Diano San Pietro",
        "Dolceacqua",
        "Dolcedo",
        "Imperia",
        "Isolabona",
        "Lucinasco",
        "Mendatica",
        "Molini di Triora",
        "Montegrosso Pian Latte",
        "Olivetta San Michele",
        "Ospedaletti",
        "Perinaldo",
        "Pietrabruna",
        "Pieve di Teco",
        "Pigna",
        "Pompeiana",
        "Pontedassio",
        "Pornassio",
        "Prelà",
        "Ranzo",
        "Rezzo",
        "Riva Ligure",
        "Rocchetta Nervina",
        "San Bartolomeo al Mare",
        "San Biagio della Cima",
        "San Lorenzo al Mare",
        "Sanremo",
        "Santo Stefano al Mare",
        "Seborga",
        "Soldano",
        "Taggia",
        "Terzorio",
        "Triora",
        "Vallebona",
        "Vallecrosia",
        "Vasia",
        "Ventimiglia",
        "Vessalico",
        "Villa Faraldi",
        "Montalto Carpasio"
    ]],
    ["AG", [
        "Agrigento",
        "Alessandria della Rocca",
        "Aragona",
        "Bivona",
        "Burgio",
        "Calamonaci",
        "Caltabellotta",
        "Camastra",
        "Cammarata",
        "Campobello di Licata",
        "Canicattì",
        "Casteltermini",
        "Castrofilippo",
        "Cattolica Eraclea",
        "Cianciana",
        "Comitini",
        "Favara",
        "Grotte",
        "Joppolo Giancaxio",
        "Lampedusa e Linosa",
        "Licata",
        "Lucca Sicula",
        "Menfi",
        "Montallegro",
        "Montevago",
        "Naro",
        "Palma di Montechiaro",
        "Porto Empedocle",
        "Racalmuto",
        "Raffadali",
        "Ravanusa",
        "Realmonte",
        "Ribera",
        "Sambuca di Sicilia",
        "San Biagio Platani",
        "San Giovanni Gemini",
        "Santa Elisabetta",
        "Santa Margherita di Belice",
        "Sant\u0027Angelo Muxaro",
        "Santo Stefano Quisquina",
        "Sciacca",
        "Siculiana",
        "Villafranca Sicula"
    ]],
    ["IS", [
        "Acquaviva d\u0027Isernia",
        "Agnone",
        "Bagnoli del Trigno",
        "Belmonte del Sannio",
        "Cantalupo nel Sannio",
        "Capracotta",
        "Carovilli",
        "Carpinone",
        "Castel del Giudice",
        "Castelpetroso",
        "Castelpizzuto",
        "Castel San Vincenzo",
        "Castelverrino",
        "Cerro al Volturno",
        "Chiauci",
        "Civitanova del Sannio",
        "Colli a Volturno",
        "Conca Casale",
        "Filignano",
        "Forlì del Sannio",
        "Fornelli",
        "Frosolone",
        "Isernia",
        "Longano",
        "Macchia d\u0027Isernia",
        "Macchiagodena",
        "Miranda",
        "Montaquila",
        "Montenero Val Cocchiara",
        "Monteroduni",
        "Pesche",
        "Pescolanciano",
        "Pescopennataro",
        "Pettoranello del Molise",
        "Pietrabbondante",
        "Pizzone",
        "Poggio Sannita",
        "Pozzilli",
        "Rionero Sannitico",
        "Roccamandolfi",
        "Roccasicura",
        "Rocchetta a Volturno",
        "San Pietro Avellana",
        "Sant\u0027Agapito",
        "Santa Maria del Molise",
        "Sant\u0027Angelo del Pesco",
        "Sant\u0027Elena Sannita",
        "Scapoli",
        "Sessano del Molise",
        "Sesto Campano",
        "Vastogirardi",
        "Venafro"
    ]],
    ["AL", [
        "Acqui Terme",
        "Albera Ligure",
        "Alessandria",
        "Alfiano Natta",
        "Alice Bel Colle",
        "Altavilla Monferrato",
        "Alzano Scrivia",
        "Arquata Scrivia",
        "Avolasca",
        "Balzola",
        "Basaluzzo",
        "Bassignana",
        "Belforte Monferrato",
        "Bergamasco",
        "Berzano di Tortona",
        "Bistagno",
        "Borghetto di Borbera",
        "Borgoratto Alessandrino",
        "Borgo San Martino",
        "Bosco Marengo",
        "Bosio",
        "Bozzole",
        "Brignano-Frascata",
        "Cabella Ligure",
        "Camagna Monferrato",
        "Camino",
        "Cantalupo Ligure",
        "Capriata d\u0027Orba",
        "Carbonara Scrivia",
        "Carentino",
        "Carezzano",
        "Carpeneto",
        "Carrega Ligure",
        "Carrosio",
        "Cartosio",
        "Casal Cermelli",
        "Casaleggio Boiro",
        "Casale Monferrato",
        "Casalnoceto",
        "Casasco",
        "Cassine",
        "Cassinelle",
        "Castellania Coppi",
        "Castellar Guidobono",
        "Castellazzo Bormida",
        "Castelletto d\u0027Erro",
        "Castelletto d\u0027Orba",
        "Castelletto Merli",
        "Castelletto Monferrato",
        "Castelnuovo Bormida",
        "Castelnuovo Scrivia",
        "Castelspina",
        "Cavatore",
        "Cella Monte",
        "Cereseto",
        "Cerreto Grue",
        "Cerrina Monferrato",
        "Coniolo",
        "Conzano",
        "Costa Vescovato",
        "Cremolino",
        "Denice",
        "Dernice",
        "Fabbrica Curone",
        "Felizzano",
        "Fraconalto",
        "Francavilla Bisio",
        "Frascaro",
        "Frassinello Monferrato",
        "Frassineto Po",
        "Fresonara",
        "Frugarolo",
        "Fubine Monferrato",
        "Gabiano",
        "Gamalero",
        "Garbagna",
        "Gavi",
        "Giarole",
        "Gremiasco",
        "Grognardo",
        "Grondona",
        "Guazzora",
        "Isola Sant\u0027Antonio",
        "Lerma",
        "Malvicino",
        "Masio",
        "Melazzo",
        "Merana",
        "Mirabello Monferrato",
        "Molare",
        "Molino dei Torti",
        "Mombello Monferrato",
        "Momperone",
        "Moncestino",
        "Mongiardino Ligure",
        "Monleale",
        "Montacuto",
        "Montaldeo",
        "Montaldo Bormida",
        "Montecastello",
        "Montechiaro d\u0027Acqui",
        "Montegioco",
        "Montemarzino",
        "Morano sul Po",
        "Morbello",
        "Mornese",
        "Morsasco",
        "Murisengo",
        "Novi Ligure",
        "Occimiano",
        "Odalengo Grande",
        "Odalengo Piccolo",
        "Olivola",
        "Orsara Bormida",
        "Ottiglio",
        "Ovada",
        "Oviglio",
        "Ozzano Monferrato",
        "Paderna",
        "Pareto",
        "Parodi Ligure",
        "Pasturana",
        "Pecetto di Valenza",
        "Pietra Marazzi",
        "Pomaro Monferrato",
        "Pontecurone",
        "Pontestura",
        "Ponti",
        "Ponzano Monferrato",
        "Ponzone",
        "Pozzol Groppo",
        "Pozzolo Formigaro",
        "Prasco",
        "Predosa",
        "Quargnento",
        "Quattordio",
        "Ricaldone",
        "Rivalta Bormida",
        "Rivarone",
        "Roccaforte Ligure",
        "Rocca Grimalda",
        "Rocchetta Ligure",
        "Rosignano Monferrato",
        "Sala Monferrato",
        "Sale",
        "San Cristoforo",
        "San Giorgio Monferrato",
        "San Salvatore Monferrato",
        "San Sebastiano Curone",
        "Sant\u0027Agata Fossili",
        "Sardigliano",
        "Sarezzano",
        "Serralunga di Crea",
        "Serravalle Scrivia",
        "Sezzadio",
        "Silvano d\u0027Orba",
        "Solero",
        "Solonghello",
        "Spigno Monferrato",
        "Spineto Scrivia",
        "Stazzano",
        "Strevi",
        "Tagliolo Monferrato",
        "Tassarolo",
        "Terruggia",
        "Terzo",
        "Ticineto",
        "Tortona",
        "Treville",
        "Trisobbio",
        "Valenza",
        "Valmacca",
        "Vignale Monferrato",
        "Vignole Borbera",
        "Viguzzolo",
        "Villadeati",
        "Villalvernia",
        "Villamiroglio",
        "Villanova Monferrato",
        "Villaromagnano",
        "Visone",
        "Volpedo",
        "Volpeglino",
        "Voltaggio",
        "Cassano Spinola",
        "Alluvioni Piovera",
        "Lu e Cuccaro Monferrato"
    ]],
    ["AN", [
        "Agugliano",
        "Ancona",
        "Arcevia",
        "Barbara",
        "Belvedere Ostrense",
        "Camerano",
        "Camerata Picena",
        "Castelbellino",
        "Castelfidardo",
        "Castelleone di Suasa",
        "Castelplanio",
        "Cerreto d\u0027Esi",
        "Chiaravalle",
        "Corinaldo",
        "Cupramontana",
        "Fabriano",
        "Falconara Marittima",
        "Filottrano",
        "Genga",
        "Jesi",
        "Loreto",
        "Maiolati Spontini",
        "Mergo",
        "Monsano",
        "Montecarotto",
        "Montemarciano",
        "Monte Roberto",
        "Monte San Vito",
        "Morro d\u0027Alba",
        "Numana",
        "Offagna",
        "Osimo",
        "Ostra",
        "Ostra Vetere",
        "Poggio San Marcello",
        "Polverigi",
        "Rosora",
        "San Marcello",
        "San Paolo di Jesi",
        "Santa Maria Nuova",
        "Sassoferrato",
        "Senigallia",
        "Serra de\u0027 Conti",
        "Serra San Quirico",
        "Sirolo",
        "Staffolo",
        "Trecastelli"
    ]],
    ["AO", [
        "Allein",
        "Antey-Saint-André",
        "Aosta",
        "Arnad",
        "Arvier",
        "Avise",
        "Ayas",
        "Aymavilles",
        "Bard",
        "Bionaz",
        "Brissogne",
        "Brusson",
        "Challand-Saint-Anselme",
        "Challand-Saint-Victor",
        "Chambave",
        "Chamois",
        "Champdepraz",
        "Champorcher",
        "Charvensod",
        "Châtillon",
        "Cogne",
        "Courmayeur",
        "Donnas",
        "Doues",
        "Emarèse",
        "Etroubles",
        "Fénis",
        "Fontainemore",
        "Gaby",
        "Gignod",
        "Gressan",
        "Gressoney-La-Trinité",
        "Gressoney-Saint-Jean",
        "Hône",
        "Introd",
        "Issime",
        "Issogne",
        "Jovençan",
        "La Magdeleine",
        "La Salle",
        "La Thuile",
        "Lillianes",
        "Montjovet",
        "Morgex",
        "Nus",
        "Ollomont",
        "Oyace",
        "Perloz",
        "Pollein",
        "Pontboset",
        "Pontey",
        "Pont-Saint-Martin",
        "Pré-Saint-Didier",
        "Quart",
        "Rhêmes-Notre-Dame",
        "Rhêmes-Saint-Georges",
        "Roisan",
        "Saint-Christophe",
        "Saint-Denis",
        "Saint-Marcel",
        "Saint-Nicolas",
        "Saint-Oyen",
        "Saint-Pierre",
        "Saint-Rhémy-en-Bosses",
        "Saint-Vincent",
        "Sarre",
        "Torgnon",
        "Valgrisenche",
        "Valpelline",
        "Valsavarenche",
        "Valtournenche",
        "Verrayes",
        "Verrès",
        "Villeneuve"
    ]],
    ["AP", [
        "Acquasanta Terme",
        "Acquaviva Picena",
        "Appignano del Tronto",
        "Arquata del Tronto",
        "Ascoli Piceno",
        "Carassai",
        "Castel di Lama",
        "Castignano",
        "Castorano",
        "Colli del Tronto",
        "Comunanza",
        "Cossignano",
        "Cupra Marittima",
        "Folignano",
        "Force",
        "Grottammare",
        "Maltignano",
        "Massignano",
        "Monsampolo del Tronto",
        "Montalto delle Marche",
        "Montedinove",
        "Montefiore dell\u0027Aso",
        "Montegallo",
        "Montemonaco",
        "Monteprandone",
        "Offida",
        "Palmiano",
        "Ripatransone",
        "Roccafluvione",
        "Rotella",
        "San Benedetto del Tronto",
        "Spinetoli",
        "Venarotta"
    ]],
    ["RA", [
        "Alfonsine",
        "Bagnacavallo",
        "Bagnara di Romagna",
        "Brisighella",
        "Casola Valsenio",
        "Castel Bolognese",
        "Cervia",
        "Conselice",
        "Cotignola",
        "Faenza",
        "Fusignano",
        "Lugo",
        "Massa Lombarda",
        "Ravenna",
        "Riolo Terme",
        "Russi",
        "Sant\u0027Agata sul Santerno",
        "Solarolo"
    ]],
    ["AQ", [
        "Acciano",
        "Aielli",
        "Alfedena",
        "Anversa degli Abruzzi",
        "Ateleta",
        "Avezzano",
        "Balsorano",
        "Barete",
        "Barisciano",
        "Barrea",
        "Bisegna",
        "Bugnara",
        "Cagnano Amiterno",
        "Calascio",
        "Campo di Giove",
        "Campotosto",
        "Canistro",
        "Cansano",
        "Capestrano",
        "Capistrello",
        "Capitignano",
        "Caporciano",
        "Cappadocia",
        "Carapelle Calvisio",
        "Carsoli",
        "Castel del Monte",
        "Castel di Ieri",
        "Castel di Sangro",
        "Castellafiume",
        "Castelvecchio Calvisio",
        "Castelvecchio Subequo",
        "Celano",
        "Cerchio",
        "Civita d\u0027Antino",
        "Civitella Alfedena",
        "Civitella Roveto",
        "Cocullo",
        "Collarmele",
        "Collelongo",
        "Collepietro",
        "Corfinio",
        "Fagnano Alto",
        "Fontecchio",
        "Fossa",
        "Gagliano Aterno",
        "Gioia dei Marsi",
        "Goriano Sicoli",
        "Introdacqua",
        "L\u0027Aquila",
        "Lecce nei Marsi",
        "Luco dei Marsi",
        "Lucoli",
        "Magliano de\u0027 Marsi",
        "Massa d\u0027Albe",
        "Molina Aterno",
        "Montereale",
        "Morino",
        "Navelli",
        "Ocre",
        "Ofena",
        "Opi",
        "Oricola",
        "Ortona dei Marsi",
        "Ortucchio",
        "Ovindoli",
        "Pacentro",
        "Pereto",
        "Pescasseroli",
        "Pescina",
        "Pescocostanzo",
        "Pettorano sul Gizio",
        "Pizzoli",
        "Poggio Picenze",
        "Prata d\u0027Ansidonia",
        "Pratola Peligna",
        "Prezza",
        "Raiano",
        "Rivisondoli",
        "Roccacasale",
        "Rocca di Botte",
        "Rocca di Cambio",
        "Rocca di Mezzo",
        "Rocca Pia",
        "Roccaraso",
        "San Benedetto dei Marsi",
        "San Benedetto in Perillis",
        "San Demetrio ne\u0027 Vestini",
        "San Pio delle Camere",
        "Sante Marie",
        "Sant\u0027Eusanio Forconese",
        "Santo Stefano di Sessanio",
        "San Vincenzo Valle Roveto",
        "Scanno",
        "Scontrone",
        "Scoppito",
        "Scurcola Marsicana",
        "Secinaro",
        "Sulmona",
        "Tagliacozzo",
        "Tione degli Abruzzi",
        "Tornimparte",
        "Trasacco",
        "Villalago",
        "Villa Santa Lucia degli Abruzzi",
        "Villa Sant\u0027Angelo",
        "Villavallelonga",
        "Villetta Barrea",
        "Vittorito"
    ]],
    ["RC", [
        "Africo",
        "Agnana Calabra",
        "Anoia",
        "Antonimina",
        "Ardore",
        "Bagaladi",
        "Bagnara Calabra",
        "Benestare",
        "Bianco",
        "Bivongi",
        "Bova",
        "Bovalino",
        "Bova Marina",
        "Brancaleone",
        "Bruzzano Zeffirio",
        "Calanna",
        "Camini",
        "Campo Calabro",
        "Candidoni",
        "Canolo",
        "Caraffa del Bianco",
        "Cardeto",
        "Careri",
        "Casignana",
        "Caulonia",
        "Ciminà",
        "Cinquefrondi",
        "Cittanova",
        "Condofuri",
        "Cosoleto",
        "Delianuova",
        "Feroleto della Chiesa",
        "Ferruzzano",
        "Fiumara",
        "Galatro",
        "Gerace",
        "Giffone",
        "Gioia Tauro",
        "Gioiosa Ionica",
        "Grotteria",
        "Laganadi",
        "Laureana di Borrello",
        "Locri",
        "Mammola",
        "Marina di Gioiosa Ionica",
        "Maropati",
        "Martone",
        "Melicuccà",
        "Melicucco",
        "Melito di Porto Salvo",
        "Molochio",
        "Monasterace",
        "Montebello Jonico",
        "Motta San Giovanni",
        "Oppido Mamertina",
        "Palizzi",
        "Palmi",
        "Pazzano",
        "Placanica",
        "Platì",
        "Polistena",
        "Portigliola",
        "Reggio di Calabria",
        "Riace",
        "Rizziconi",
        "Roccaforte del Greco",
        "Roccella Ionica",
        "Roghudi",
        "Rosarno",
        "Samo",
        "San Giorgio Morgeto",
        "San Giovanni di Gerace",
        "San Lorenzo",
        "San Luca",
        "San Pietro di Caridà",
        "San Procopio",
        "San Roberto",
        "Santa Cristina d\u0027Aspromonte",
        "Sant\u0027Agata del Bianco",
        "Sant\u0027Alessio in Aspromonte",
        "Sant\u0027Eufemia d\u0027Aspromonte",
        "Sant\u0027Ilario dello Ionio",
        "Santo Stefano in Aspromonte",
        "Scido",
        "Scilla",
        "Seminara",
        "Serrata",
        "Siderno",
        "Sinopoli",
        "Staiti",
        "Stignano",
        "Stilo",
        "Taurianova",
        "Terranova Sappo Minulio",
        "Varapodio",
        "Villa San Giovanni",
        "San Ferdinando"
    ]],
    ["AR", [
        "Anghiari",
        "Arezzo",
        "Badia Tedalda",
        "Bibbiena",
        "Bucine",
        "Capolona",
        "Caprese Michelangelo",
        "Castel Focognano",
        "Castel San Niccolò",
        "Castiglion Fibocchi",
        "Castiglion Fiorentino",
        "Cavriglia",
        "Chitignano",
        "Chiusi della Verna",
        "Civitella in Val di Chiana",
        "Cortona",
        "Foiano della Chiana",
        "Loro Ciuffenna",
        "Lucignano",
        "Marciano della Chiana",
        "Montemignaio",
        "Monterchi",
        "Monte San Savino",
        "Montevarchi",
        "Ortignano Raggiolo",
        "Pieve Santo Stefano",
        "Poppi",
        "San Giovanni Valdarno",
        "Sansepolcro",
        "Sestino",
        "Subbiano",
        "Talla",
        "Terranuova Bracciolini",
        "Castelfranco Piandiscò",
        "Pratovecchio Stia",
        "Laterina Pergine Valdarno"
    ]],
    ["RE", [
        "Albinea",
        "Bagnolo in Piano",
        "Baiso",
        "Bibbiano",
        "Boretto",
        "Brescello",
        "Cadelbosco di Sopra",
        "Campagnola Emilia",
        "Campegine",
        "Carpineti",
        "Casalgrande",
        "Casina",
        "Castellarano",
        "Castelnovo di Sotto",
        "Castelnovo ne\u0027 Monti",
        "Cavriago",
        "Canossa",
        "Correggio",
        "Fabbrico",
        "Gattatico",
        "Gualtieri",
        "Guastalla",
        "Luzzara",
        "Montecchio Emilia",
        "Novellara",
        "Poviglio",
        "Quattro Castella",
        "Reggiolo",
        "Reggio nell\u0027Emilia",
        "Rio Saliceto",
        "Rolo",
        "Rubiera",
        "San Martino in Rio",
        "San Polo d\u0027Enza",
        "Sant\u0027Ilario d\u0027Enza",
        "Scandiano",
        "Toano",
        "Vetto",
        "Vezzano sul Crostolo",
        "Viano",
        "Villa Minozzo",
        "Ventasso"
    ]],
    ["AT", [
        "Agliano Terme",
        "Albugnano",
        "Antignano",
        "Aramengo",
        "Asti",
        "Azzano d\u0027Asti",
        "Baldichieri d\u0027Asti",
        "Belveglio",
        "Berzano di San Pietro",
        "Bruno",
        "Bubbio",
        "Buttigliera d\u0027Asti",
        "Calamandrana",
        "Calliano Monferrato",
        "Calosso",
        "Camerano Casasco",
        "Canelli",
        "Cantarana",
        "Capriglio",
        "Casorzo Monferrato",
        "Cassinasco",
        "Castagnole delle Lanze",
        "Castagnole Monferrato",
        "Castel Boglione",
        "Castell\u0027Alfero",
        "Castellero",
        "Castelletto Molina",
        "Castello di Annone",
        "Castelnuovo Belbo",
        "Castelnuovo Calcea",
        "Castelnuovo Don Bosco",
        "Castel Rocchero",
        "Cellarengo",
        "Celle Enomondo",
        "Cerreto d\u0027Asti",
        "Cerro Tanaro",
        "Cessole",
        "Chiusano d\u0027Asti",
        "Cinaglio",
        "Cisterna d\u0027Asti",
        "Coazzolo",
        "Cocconato",
        "Corsione",
        "Cortandone",
        "Cortanze",
        "Cortazzone",
        "Cortiglione",
        "Cossombrato",
        "Costigliole d\u0027Asti",
        "Cunico",
        "Dusino San Michele",
        "Ferrere",
        "Fontanile",
        "Frinco",
        "Grana Monferrato",
        "Grazzano Badoglio",
        "Incisa Scapaccino",
        "Isola d\u0027Asti",
        "Loazzolo",
        "Maranzana",
        "Maretto",
        "Moasca",
        "Mombaldone",
        "Mombaruzzo",
        "Mombercelli",
        "Monale",
        "Monastero Bormida",
        "Moncalvo",
        "Moncucco Torinese",
        "Mongardino",
        "Montabone",
        "Montafia",
        "Montaldo Scarampi",
        "Montechiaro d\u0027Asti",
        "Montegrosso d\u0027Asti",
        "Montemagno Monferrato",
        "Nizza Monferrato",
        "Olmo Gentile",
        "Passerano Marmorito",
        "Penango",
        "Piea",
        "Pino d\u0027Asti",
        "Piovà Massaia",
        "Portacomaro",
        "Quaranti",
        "Refrancore",
        "Revigliasco d\u0027Asti",
        "Roatto",
        "Robella",
        "Rocca d\u0027Arazzo",
        "Roccaverano",
        "Rocchetta Palafea",
        "Rocchetta Tanaro",
        "San Damiano d\u0027Asti",
        "San Giorgio Scarampi",
        "San Martino Alfieri",
        "San Marzano Oliveto",
        "San Paolo Solbrito",
        "Scurzolengo",
        "Serole",
        "Sessame",
        "Settime",
        "Soglio",
        "Tigliole",
        "Tonco",
        "Vaglio Serra",
        "Valfenera",
        "Vesime",
        "Viale",
        "Viarigi",
        "Vigliano d\u0027Asti",
        "Villafranca d\u0027Asti",
        "Villanova d\u0027Asti",
        "Villa San Secondo",
        "Vinchio",
        "Montiglio Monferrato",
        "Moransengo-Tonengo"
    ]],
    ["RG", [
        "Acate",
        "Chiaramonte Gulfi",
        "Comiso",
        "Giarratana",
        "Ispica",
        "Modica",
        "Monterosso Almo",
        "Pozzallo",
        "Ragusa",
        "Santa Croce Camerina",
        "Scicli",
        "Vittoria"
    ]],
    ["AV", [
        "Aiello del Sabato",
        "Altavilla Irpina",
        "Andretta",
        "Aquilonia",
        "Ariano Irpino",
        "Atripalda",
        "Avella",
        "Avellino",
        "Bagnoli Irpino",
        "Baiano",
        "Bisaccia",
        "Bonito",
        "Cairano",
        "Calabritto",
        "Calitri",
        "Candida",
        "Caposele",
        "Capriglia Irpina",
        "Carife",
        "Casalbore",
        "Cassano Irpino",
        "Castel Baronia",
        "Castelfranci",
        "Castelvetere sul Calore",
        "Cervinara",
        "Cesinali",
        "Chianche",
        "Chiusano di San Domenico",
        "Contrada",
        "Conza della Campania",
        "Domicella",
        "Flumeri",
        "Fontanarosa",
        "Forino",
        "Frigento",
        "Gesualdo",
        "Greci",
        "Grottaminarda",
        "Grottolella",
        "Guardia Lombardi",
        "Lacedonia",
        "Lapio",
        "Lauro",
        "Lioni",
        "Luogosano",
        "Manocalzati",
        "Marzano di Nola",
        "Melito Irpino",
        "Mercogliano",
        "Mirabella Eclano",
        "Montaguto",
        "Montecalvo Irpino",
        "Montefalcione",
        "Monteforte Irpino",
        "Montefredane",
        "Montefusco",
        "Montella",
        "Montemarano",
        "Montemiletto",
        "Monteverde",
        "Morra De Sanctis",
        "Moschiano",
        "Mugnano del Cardinale",
        "Nusco",
        "Ospedaletto d\u0027Alpinolo",
        "Pago del Vallo di Lauro",
        "Parolise",
        "Paternopoli",
        "Petruro Irpino",
        "Pietradefusi",
        "Pietrastornina",
        "Prata di Principato Ultra",
        "Pratola Serra",
        "Quadrelle",
        "Quindici",
        "Roccabascerana",
        "Rocca San Felice",
        "Rotondi",
        "Salza Irpina",
        "San Mango sul Calore",
        "San Martino Valle Caudina",
        "San Michele di Serino",
        "San Nicola Baronia",
        "San Potito Ultra",
        "San Sossio Baronia",
        "Santa Lucia di Serino",
        "Sant\u0027Andrea di Conza",
        "Sant\u0027Angelo all\u0027Esca",
        "Sant\u0027Angelo a Scala",
        "Sant\u0027Angelo dei Lombardi",
        "Santa Paolina",
        "Santo Stefano del Sole",
        "Savignano Irpino",
        "Scampitella",
        "Senerchia",
        "Serino",
        "Sirignano",
        "Solofra",
        "Sorbo Serpico",
        "Sperone",
        "Sturno",
        "Summonte",
        "Taurano",
        "Taurasi",
        "Teora",
        "Torella dei Lombardi",
        "Torre Le Nocelle",
        "Torrioni",
        "Trevico",
        "Tufo",
        "Vallata",
        "Vallesaccarda",
        "Venticano",
        "Villamaina",
        "Villanova del Battista",
        "Volturara Irpina",
        "Zungoli",
        "Montoro"
    ]],
    ["RI", [
        "Accumoli",
        "Amatrice",
        "Antrodoco",
        "Ascrea",
        "Belmonte in Sabina",
        "Borbona",
        "Borgorose",
        "Borgo Velino",
        "Cantalice",
        "Cantalupo in Sabina",
        "Casaprota",
        "Casperia",
        "Castel di Tora",
        "Castelnuovo di Farfa",
        "Castel Sant\u0027Angelo",
        "Cittaducale",
        "Cittareale",
        "Collalto Sabino",
        "Colle di Tora",
        "Collegiove",
        "Collevecchio",
        "Colli sul Velino",
        "Concerviano",
        "Configni",
        "Contigliano",
        "Cottanello",
        "Fara in Sabina",
        "Fiamignano",
        "Forano",
        "Frasso Sabino",
        "Greccio",
        "Labro",
        "Leonessa",
        "Longone Sabino",
        "Magliano Sabina",
        "Marcetelli",
        "Micigliano",
        "Mompeo",
        "Montasola",
        "Montebuono",
        "Monteleone Sabino",
        "Montenero Sabino",
        "Monte San Giovanni in Sabina",
        "Montopoli di Sabina",
        "Morro Reatino",
        "Nespolo",
        "Orvinio",
        "Paganico Sabino",
        "Pescorocchiano",
        "Petrella Salto",
        "Poggio Bustone",
        "Poggio Catino",
        "Poggio Mirteto",
        "Poggio Moiano",
        "Poggio Nativo",
        "Poggio San Lorenzo",
        "Posta",
        "Pozzaglia Sabina",
        "Rieti",
        "Rivodutri",
        "Roccantica",
        "Rocca Sinibalda",
        "Salisano",
        "Scandriglia",
        "Selci",
        "Stimigliano",
        "Tarano",
        "Toffia",
        "Torricella in Sabina",
        "Torri in Sabina",
        "Turania",
        "Vacone",
        "Varco Sabino"
    ]],
    ["RM", [
        "Affile",
        "Agosta",
        "Albano Laziale",
        "Allumiere",
        "Anguillara Sabazia",
        "Anticoli Corrado",
        "Anzio",
        "Arcinazzo Romano",
        "Ariccia",
        "Arsoli",
        "Artena",
        "Bellegra",
        "Bracciano",
        "Camerata Nuova",
        "Campagnano di Roma",
        "Canale Monterano",
        "Canterano",
        "Capena",
        "Capranica Prenestina",
        "Carpineto Romano",
        "Casape",
        "Castel Gandolfo",
        "Castel Madama",
        "Castelnuovo di Porto",
        "Castel San Pietro Romano",
        "Cave",
        "Cerreto Laziale",
        "Cervara di Roma",
        "Cerveteri",
        "Ciciliano",
        "Cineto Romano",
        "Civitavecchia",
        "Civitella San Paolo",
        "Colleferro",
        "Colonna",
        "Fiano Romano",
        "Filacciano",
        "Formello",
        "Frascati",
        "Gallicano nel Lazio",
        "Gavignano",
        "Genazzano",
        "Genzano di Roma",
        "Gerano",
        "Gorga",
        "Grottaferrata",
        "Guidonia Montecelio",
        "Jenne",
        "Labico",
        "Lanuvio",
        "Licenza",
        "Magliano Romano",
        "Mandela",
        "Manziana",
        "Marano Equo",
        "Marcellina",
        "Marino",
        "Mazzano Romano",
        "Mentana",
        "Monte Compatri",
        "Monteflavio",
        "Montelanico",
        "Montelibretti",
        "Monte Porzio Catone",
        "Monterotondo",
        "Montorio Romano",
        "Moricone",
        "Morlupo",
        "Nazzano",
        "Nemi",
        "Nerola",
        "Nettuno",
        "Olevano Romano",
        "Palestrina",
        "Palombara Sabina",
        "Percile",
        "Pisoniano",
        "Poli",
        "Pomezia",
        "Ponzano Romano",
        "Riano",
        "Rignano Flaminio",
        "Riofreddo",
        "Rocca Canterano",
        "Rocca di Cave",
        "Rocca di Papa",
        "Roccagiovine",
        "Rocca Priora",
        "Rocca Santo Stefano",
        "Roiate",
        "Roma",
        "Roviano",
        "Sacrofano",
        "Sambuci",
        "San Gregorio da Sassola",
        "San Polo dei Cavalieri",
        "Santa Marinella",
        "Sant\u0027Angelo Romano",
        "Sant\u0027Oreste",
        "San Vito Romano",
        "Saracinesco",
        "Segni",
        "Subiaco",
        "Tivoli",
        "Tolfa",
        "Torrita Tiberina",
        "Trevignano Romano",
        "Vallepietra",
        "Vallinfreda",
        "Valmontone",
        "Velletri",
        "Vicovaro",
        "Vivaro Romano",
        "Zagarolo",
        "Lariano",
        "Ladispoli",
        "Ardea",
        "Ciampino",
        "San Cesareo",
        "Fiumicino",
        "Fonte Nuova"
    ]],
    ["RN", [
        "Bellaria-Igea Marina",
        "Cattolica",
        "Coriano",
        "Gemmano",
        "Misano Adriatico",
        "Mondaino",
        "Montefiore Conca",
        "Montegridolfo",
        "Morciano di Romagna",
        "Riccione",
        "Rimini",
        "Saludecio",
        "San Clemente",
        "San Giovanni in Marignano",
        "Santarcangelo di Romagna",
        "Verucchio",
        "Casteldelci",
        "Maiolo",
        "Novafeltria",
        "Pennabilli",
        "San Leo",
        "Sant\u0027Agata Feltria",
        "Talamello",
        "Poggio Torriana",
        "Montescudo-Monte Colombo",
        "Montecopiolo",
        "Sassofeltrio"
    ]],
    ["RO", [
        "Adria",
        "Ariano nel Polesine",
        "Arquà Polesine",
        "Badia Polesine",
        "Bagnolo di Po",
        "Bergantino",
        "Bosaro",
        "Calto",
        "Canaro",
        "Canda",
        "Castelguglielmo",
        "Castelmassa",
        "Castelnovo Bariano",
        "Ceneselli",
        "Ceregnano",
        "Corbola",
        "Costa di Rovigo",
        "Crespino",
        "Ficarolo",
        "Fiesso Umbertiano",
        "Frassinelle Polesine",
        "Fratta Polesine",
        "Gaiba",
        "Gavello",
        "Giacciano con Baruchella",
        "Guarda Veneta",
        "Lendinara",
        "Loreo",
        "Lusia",
        "Melara",
        "Occhiobello",
        "Papozze",
        "Pettorazza Grimani",
        "Pincara",
        "Polesella",
        "Pontecchio Polesine",
        "Porto Tolle",
        "Rosolina",
        "Rovigo",
        "Salara",
        "San Bellino",
        "San Martino di Venezze",
        "Stienta",
        "Taglio di Po",
        "Trecenta",
        "Villadose",
        "Villamarzana",
        "Villanova del Ghebbo",
        "Villanova Marchesana",
        "Porto Viro"
    ]],
    ["BA", [
        "Acquaviva delle Fonti",
        "Adelfia",
        "Alberobello",
        "Altamura",
        "Bari",
        "Binetto",
        "Bitetto",
        "Bitonto",
        "Bitritto",
        "Capurso",
        "Casamassima",
        "Cassano delle Murge",
        "Castellana Grotte",
        "Cellamare",
        "Conversano",
        "Corato",
        "Gioia del Colle",
        "Giovinazzo",
        "Gravina in Puglia",
        "Grumo Appula",
        "Locorotondo",
        "Modugno",
        "Mola di Bari",
        "Molfetta",
        "Monopoli",
        "Noci",
        "Noicattaro",
        "Palo del Colle",
        "Poggiorsini",
        "Polignano a Mare",
        "Putignano",
        "Rutigliano",
        "Ruvo di Puglia",
        "Sammichele di Bari",
        "Sannicandro di Bari",
        "Santeramo in Colle",
        "Terlizzi",
        "Toritto",
        "Triggiano",
        "Turi",
        "Valenzano"
    ]],
    ["BG", [
        "Adrara San Martino",
        "Adrara San Rocco",
        "Albano Sant\u0027Alessandro",
        "Albino",
        "Almè",
        "Almenno San Bartolomeo",
        "Almenno San Salvatore",
        "Alzano Lombardo",
        "Ambivere",
        "Antegnate",
        "Arcene",
        "Ardesio",
        "Arzago d\u0027Adda",
        "Averara",
        "Aviatico",
        "Azzano San Paolo",
        "Azzone",
        "Bagnatica",
        "Barbata",
        "Bariano",
        "Barzana",
        "Bedulita",
        "Berbenno",
        "Bergamo",
        "Berzo San Fermo",
        "Bianzano",
        "Blello",
        "Bolgare",
        "Boltiere",
        "Bonate Sopra",
        "Bonate Sotto",
        "Borgo di Terzo",
        "Bossico",
        "Bottanuco",
        "Bracca",
        "Branzi",
        "Brembate",
        "Brembate di Sopra",
        "Brignano Gera d\u0027Adda",
        "Brumano",
        "Brusaporto",
        "Calcinate",
        "Calcio",
        "Calusco d\u0027Adda",
        "Calvenzano",
        "Camerata Cornello",
        "Canonica d\u0027Adda",
        "Capizzone",
        "Capriate San Gervasio",
        "Caprino Bergamasco",
        "Caravaggio",
        "Carobbio degli Angeli",
        "Carona",
        "Carvico",
        "Casazza",
        "Casirate d\u0027Adda",
        "Casnigo",
        "Cassiglio",
        "Castelli Calepio",
        "Castel Rozzone",
        "Castione della Presolana",
        "Castro",
        "Cavernago",
        "Cazzano Sant\u0027Andrea",
        "Cenate Sopra",
        "Cenate Sotto",
        "Cene",
        "Cerete",
        "Chignolo d\u0027Isola",
        "Chiuduno",
        "Cisano Bergamasco",
        "Ciserano",
        "Cividate al Piano",
        "Clusone",
        "Colere",
        "Cologno al Serio",
        "Colzate",
        "Comun Nuovo",
        "Corna Imagna",
        "Cortenuova",
        "Costa di Mezzate",
        "Costa Valle Imagna",
        "Costa Volpino",
        "Covo",
        "Credaro",
        "Curno",
        "Cusio",
        "Dalmine",
        "Dossena",
        "Endine Gaiano",
        "Entratico",
        "Fara Gera d\u0027Adda",
        "Fara Olivana con Sola",
        "Filago",
        "Fino del Monte",
        "Fiorano al Serio",
        "Fontanella",
        "Fonteno",
        "Foppolo",
        "Foresto Sparso",
        "Fornovo San Giovanni",
        "Fuipiano Valle Imagna",
        "Gandellino",
        "Gandino",
        "Gandosso",
        "Gaverina Terme",
        "Gazzaniga",
        "Ghisalba",
        "Gorlago",
        "Gorle",
        "Gorno",
        "Grassobbio",
        "Gromo",
        "Grone",
        "Grumello del Monte",
        "Isola di Fondra",
        "Isso",
        "Lallio",
        "Leffe",
        "Lenna",
        "Levate",
        "Locatello",
        "Lovere",
        "Lurano",
        "Luzzana",
        "Madone",
        "Mapello",
        "Martinengo",
        "Mezzoldo",
        "Misano di Gera d\u0027Adda",
        "Moio de\u0027 Calvi",
        "Monasterolo del Castello",
        "Montello",
        "Morengo",
        "Mornico al Serio",
        "Mozzanica",
        "Mozzo",
        "Nembro",
        "Olmo al Brembo",
        "Oltre il Colle",
        "Oltressenda Alta",
        "Oneta",
        "Onore",
        "Orio al Serio",
        "Ornica",
        "Osio Sopra",
        "Osio Sotto",
        "Pagazzano",
        "Paladina",
        "Palazzago",
        "Palosco",
        "Parre",
        "Parzanica",
        "Pedrengo",
        "Peia",
        "Pianico",
        "Piario",
        "Piazza Brembana",
        "Piazzatorre",
        "Piazzolo",
        "Pognano",
        "Ponte Nossa",
        "Ponteranica",
        "Ponte San Pietro",
        "Pontida",
        "Pontirolo Nuovo",
        "Pradalunga",
        "Predore",
        "Premolo",
        "Presezzo",
        "Pumenengo",
        "Ranica",
        "Ranzanico",
        "Riva di Solto",
        "Rogno",
        "Romano di Lombardia",
        "Roncobello",
        "Roncola",
        "Rota d\u0027Imagna",
        "Rovetta",
        "San Giovanni Bianco",
        "San Paolo d\u0027Argon",
        "San Pellegrino Terme",
        "Santa Brigida",
        "Sarnico",
        "Scanzorosciate",
        "Schilpario",
        "Sedrina",
        "Selvino",
        "Seriate",
        "Serina",
        "Solto Collina",
        "Songavazzo",
        "Sorisole",
        "Sotto il Monte Giovanni XXIII",
        "Sovere",
        "Spinone al Lago",
        "Spirano",
        "Stezzano",
        "Strozza",
        "Suisio",
        "Taleggio",
        "Tavernola Bergamasca",
        "Telgate",
        "Terno d\u0027Isola",
        "Torre Boldone",
        "Torre de\u0027 Busi",
        "Torre de\u0027 Roveri",
        "Torre Pallavicina",
        "Trescore Balneario",
        "Treviglio",
        "Treviolo",
        "Ubiale Clanezzo",
        "Urgnano",
        "Valbondione",
        "Valbrembo",
        "Valgoglio",
        "Valleve",
        "Valnegra",
        "Valtorta",
        "Vedeseta",
        "Verdellino",
        "Verdello",
        "Vertova",
        "Viadanica",
        "Vigano San Martino",
        "Vigolo",
        "Villa d\u0027Adda",
        "Villa d\u0027Almè",
        "Villa di Serio",
        "Villa d\u0027Ogna",
        "Villongo",
        "Vilminore di Scalve",
        "Zandobbio",
        "Zanica",
        "Zogno",
        "Costa Serina",
        "Algua",
        "Cornalba",
        "Medolago",
        "Solza",
        "Sant\u0027Omobono Terme",
        "Val Brembilla"
    ]],
    ["BI", [
        "Ailoche",
        "Andorno Micca",
        "Benna",
        "Biella",
        "Bioglio",
        "Borriana",
        "Brusnengo",
        "Callabiana",
        "Camandona",
        "Camburzano",
        "Candelo",
        "Caprile",
        "Casapinta",
        "Castelletto Cervo",
        "Cavaglià",
        "Cerrione",
        "Coggiola",
        "Cossato",
        "Crevacuore",
        "Curino",
        "Donato",
        "Dorzano",
        "Gaglianico",
        "Gifflenga",
        "Graglia",
        "Magnano",
        "Massazza",
        "Masserano",
        "Mezzana Mortigliengo",
        "Miagliano",
        "Mongrando",
        "Mottalciata",
        "Muzzano",
        "Netro",
        "Occhieppo Inferiore",
        "Occhieppo Superiore",
        "Pettinengo",
        "Piatto",
        "Piedicavallo",
        "Pollone",
        "Ponderano",
        "Portula",
        "Pralungo",
        "Pray",
        "Ronco Biellese",
        "Roppolo",
        "Rosazza",
        "Sagliano Micca",
        "Sala Biellese",
        "Salussola",
        "Sandigliano",
        "Sordevolo",
        "Sostegno",
        "Strona",
        "Tavigliano",
        "Ternengo",
        "Tollegno",
        "Torrazzo",
        "Valdengo",
        "Vallanzengo",
        "Valle San Nicolao",
        "Veglio",
        "Verrone",
        "Vigliano Biellese",
        "Villa del Bosco",
        "Villanova Biellese",
        "Viverone",
        "Zimone",
        "Zubiena",
        "Zumaglia",
        "Lessona",
        "Campiglia Cervo",
        "Quaregna Cerreto",
        "Valdilana"
    ]],
    ["BL", [
        "Agordo",
        "Alleghe",
        "Arsiè",
        "Auronzo di Cadore",
        "Belluno",
        "Borca di Cadore",
        "Calalzo di Cadore",
        "Cencenighe Agordino",
        "Cesiomaggiore",
        "Chies d\u0027Alpago",
        "Cibiana di Cadore",
        "Colle Santa Lucia",
        "Comelico Superiore",
        "Cortina d\u0027Ampezzo",
        "Danta di Cadore",
        "Domegge di Cadore",
        "Falcade",
        "Feltre",
        "Fonzaso",
        "Canale d\u0027Agordo",
        "Gosaldo",
        "Lamon",
        "La Valle Agordina",
        "Limana",
        "Livinallongo del Col di Lana",
        "Lorenzago di Cadore",
        "Lozzo di Cadore",
        "Ospitale di Cadore",
        "Pedavena",
        "Perarolo di Cadore",
        "Pieve di Cadore",
        "Ponte nelle Alpi",
        "Rivamonte Agordino",
        "Rocca Pietore",
        "San Gregorio nelle Alpi",
        "San Nicolò di Comelico",
        "San Pietro di Cadore",
        "Santa Giustina",
        "San Tomaso Agordino",
        "Santo Stefano di Cadore",
        "San Vito di Cadore",
        "Sedico",
        "Selva di Cadore",
        "Seren del Grappa",
        "Sospirolo",
        "Soverzene",
        "Sovramonte",
        "Taibon Agordino",
        "Tambre",
        "Vallada Agordina",
        "Valle di Cadore",
        "Vigo di Cadore",
        "Vodo Cadore",
        "Voltago Agordino",
        "Zoppè di Cadore",
        "Longarone",
        "Alpago",
        "Val di Zoldo",
        "Borgo Valbelluna",
        "Setteville"
    ]],
    ["BN", [
        "Airola",
        "Amorosi",
        "Apice",
        "Apollosa",
        "Arpaia",
        "Arpaise",
        "Baselice",
        "Benevento",
        "Bonea",
        "Bucciano",
        "Buonalbergo",
        "Calvi",
        "Campolattaro",
        "Campoli del Monte Taburno",
        "Casalduni",
        "Castelfranco in Miscano",
        "Castelpagano",
        "Castelpoto",
        "Castelvenere",
        "Castelvetere in Val Fortore",
        "Cautano",
        "Ceppaloni",
        "Cerreto Sannita",
        "Circello",
        "Colle Sannita",
        "Cusano Mutri",
        "Dugenta",
        "Durazzano",
        "Faicchio",
        "Foglianise",
        "Foiano di Val Fortore",
        "Forchia",
        "Fragneto l\u0027Abate",
        "Fragneto Monforte",
        "Frasso Telesino",
        "Ginestra degli Schiavoni",
        "Guardia Sanframondi",
        "Limatola",
        "Melizzano",
        "Moiano",
        "Molinara",
        "Montefalcone di Val Fortore",
        "Montesarchio",
        "Morcone",
        "Paduli",
        "Pago Veiano",
        "Pannarano",
        "Paolisi",
        "Paupisi",
        "Pesco Sannita",
        "Pietraroja",
        "Pietrelcina",
        "Ponte",
        "Pontelandolfo",
        "Puglianello",
        "Reino",
        "San Bartolomeo in Galdo",
        "San Giorgio del Sannio",
        "San Giorgio La Molara",
        "San Leucio del Sannio",
        "San Lorenzello",
        "San Lorenzo Maggiore",
        "San Lupo",
        "San Marco dei Cavoti",
        "San Martino Sannita",
        "San Nazzaro",
        "San Nicola Manfredi",
        "San Salvatore Telesino",
        "Santa Croce del Sannio",
        "Sant\u0027Agata de\u0027 Goti",
        "Sant\u0027Angelo a Cupolo",
        "Sassinoro",
        "Solopaca",
        "Telese Terme",
        "Tocco Caudio",
        "Torrecuso",
        "Vitulano",
        "Sant\u0027Arcangelo Trimonte"
    ]],
    ["BO", [
        "Anzola dell\u0027Emilia",
        "Argelato",
        "Baricella",
        "Bentivoglio",
        "Bologna",
        "Borgo Tossignano",
        "Budrio",
        "Calderara di Reno",
        "Camugnano",
        "Casalecchio di Reno",
        "Casalfiumanese",
        "Castel d\u0027Aiano",
        "Castel del Rio",
        "Castel di Casio",
        "Castel Guelfo di Bologna",
        "Castello d\u0027Argile",
        "Castel Maggiore",
        "Castel San Pietro Terme",
        "Castenaso",
        "Castiglione dei Pepoli",
        "Crevalcore",
        "Dozza",
        "Fontanelice",
        "Gaggio Montano",
        "Galliera",
        "Granarolo dell\u0027Emilia",
        "Grizzana Morandi",
        "Imola",
        "Lizzano in Belvedere",
        "Loiano",
        "Malalbergo",
        "Marzabotto",
        "Medicina",
        "Minerbio",
        "Molinella",
        "Monghidoro",
        "Monterenzio",
        "Monte San Pietro",
        "Monzuno",
        "Mordano",
        "Ozzano dell\u0027Emilia",
        "Pianoro",
        "Pieve di Cento",
        "Sala Bolognese",
        "San Benedetto Val di Sambro",
        "San Giorgio di Piano",
        "San Giovanni in Persiceto",
        "San Lazzaro di Savena",
        "San Pietro in Casale",
        "Sant\u0027Agata Bolognese",
        "Sasso Marconi",
        "Vergato",
        "Zola Predosa",
        "Valsamoggia",
        "Alto Reno Terme"
    ]],
    ["SA", [
        "Acerno",
        "Agropoli",
        "Albanella",
        "Alfano",
        "Altavilla Silentina",
        "Amalfi",
        "Angri",
        "Aquara",
        "Ascea",
        "Atena Lucana",
        "Atrani",
        "Auletta",
        "Baronissi",
        "Battipaglia",
        "Bellosguardo",
        "Bracigliano",
        "Buccino",
        "Buonabitacolo",
        "Caggiano",
        "Calvanico",
        "Camerota",
        "Campagna",
        "Campora",
        "Cannalonga",
        "Capaccio Paestum",
        "Casalbuono",
        "Casaletto Spartano",
        "Casal Velino",
        "Caselle in Pittari",
        "Castelcivita",
        "Castellabate",
        "Castelnuovo Cilento",
        "Castelnuovo di Conza",
        "Castel San Giorgio",
        "Castel San Lorenzo",
        "Castiglione del Genovesi",
        "Cava de\u0027 Tirreni",
        "Celle di Bulgheria",
        "Centola",
        "Ceraso",
        "Cetara",
        "Cicerale",
        "Colliano",
        "Conca dei Marini",
        "Controne",
        "Contursi Terme",
        "Corbara",
        "Corleto Monforte",
        "Cuccaro Vetere",
        "Eboli",
        "Felitto",
        "Fisciano",
        "Furore",
        "Futani",
        "Giffoni Sei Casali",
        "Giffoni Valle Piana",
        "Gioi",
        "Giungano",
        "Ispani",
        "Laureana Cilento",
        "Laurino",
        "Laurito",
        "Laviano",
        "Lustra",
        "Magliano Vetere",
        "Maiori",
        "Mercato San Severino",
        "Minori",
        "Moio della Civitella",
        "Montano Antilia",
        "Montecorice",
        "Montecorvino Pugliano",
        "Montecorvino Rovella",
        "Monteforte Cilento",
        "Monte San Giacomo",
        "Montesano sulla Marcellana",
        "Morigerati",
        "Nocera Inferiore",
        "Nocera Superiore",
        "Novi Velia",
        "Ogliastro Cilento",
        "Olevano sul Tusciano",
        "Oliveto Citra",
        "Omignano",
        "Orria",
        "Ottati",
        "Padula",
        "Pagani",
        "Palomonte",
        "Pellezzano",
        "Perdifumo",
        "Perito",
        "Pertosa",
        "Petina",
        "Piaggine",
        "Pisciotta",
        "Polla",
        "Pollica",
        "Pontecagnano Faiano",
        "Positano",
        "Postiglione",
        "Praiano",
        "Prignano Cilento",
        "Ravello",
        "Ricigliano",
        "Roccadaspide",
        "Roccagloriosa",
        "Roccapiemonte",
        "Rofrano",
        "Romagnano al Monte",
        "Roscigno",
        "Rutino",
        "Sacco",
        "Sala Consilina",
        "Salento",
        "Salerno",
        "Salvitelle",
        "San Cipriano Picentino",
        "San Giovanni a Piro",
        "San Gregorio Magno",
        "San Mango Piemonte",
        "San Marzano sul Sarno",
        "San Mauro Cilento",
        "San Mauro la Bruca",
        "San Pietro al Tanagro",
        "San Rufo",
        "Santa Marina",
        "Sant\u0027Angelo a Fasanella",
        "Sant\u0027Arsenio",
        "Sant\u0027Egidio del Monte Albino",
        "Santomenna",
        "San Valentino Torio",
        "Sanza",
        "Sapri",
        "Sarno",
        "Sassano",
        "Scafati",
        "Scala",
        "Serramezzana",
        "Serre",
        "Sessa Cilento",
        "Siano",
        "Sicignano degli Alburni",
        "Stella Cilento",
        "Stio",
        "Teggiano",
        "Torchiara",
        "Torraca",
        "Torre Orsaia",
        "Tortorella",
        "Tramonti",
        "Trentinara",
        "Valle dell\u0027Angelo",
        "Vallo della Lucania",
        "Valva",
        "Vibonati",
        "Vietri sul Mare",
        "Bellizzi"
    ]],
    ["BR", [
        "Brindisi",
        "Carovigno",
        "Ceglie Messapica",
        "Cellino San Marco",
        "Cisternino",
        "Erchie",
        "Fasano",
        "Francavilla Fontana",
        "Latiano",
        "Mesagne",
        "Oria",
        "Ostuni",
        "San Donaci",
        "San Michele Salentino",
        "San Pancrazio Salentino",
        "San Pietro Vernotico",
        "San Vito dei Normanni",
        "Torchiarolo",
        "Torre Santa Susanna",
        "Villa Castelli"
    ]],
    ["BS", [
        "Acquafredda",
        "Adro",
        "Agnosine",
        "Alfianello",
        "Anfo",
        "Angolo Terme",
        "Artogne",
        "Azzano Mella",
        "Bagnolo Mella",
        "Bagolino",
        "Barbariga",
        "Barghe",
        "Bassano Bresciano",
        "Bedizzole",
        "Berlingo",
        "Berzo Demo",
        "Berzo Inferiore",
        "Bienno",
        "Bione",
        "Borgo San Giacomo",
        "Borgosatollo",
        "Borno",
        "Botticino",
        "Bovegno",
        "Bovezzo",
        "Brandico",
        "Braone",
        "Breno",
        "Brescia",
        "Brione",
        "Caino",
        "Calcinato",
        "Calvagese della Riviera",
        "Calvisano",
        "Capo di Ponte",
        "Capovalle",
        "Capriano del Colle",
        "Capriolo",
        "Carpenedolo",
        "Castegnato",
        "Castelcovati",
        "Castel Mella",
        "Castenedolo",
        "Casto",
        "Castrezzato",
        "Cazzago San Martino",
        "Cedegolo",
        "Cellatica",
        "Cerveno",
        "Ceto",
        "Cevo",
        "Chiari",
        "Cigole",
        "Cimbergo",
        "Cividate Camuno",
        "Coccaglio",
        "Collebeato",
        "Collio",
        "Cologne",
        "Comezzano-Cizzago",
        "Concesio",
        "Corte Franca",
        "Corteno Golgi",
        "Corzano",
        "Darfo Boario Terme",
        "Dello",
        "Desenzano del Garda",
        "Edolo",
        "Erbusco",
        "Esine",
        "Fiesse",
        "Flero",
        "Gambara",
        "Gardone Riviera",
        "Gardone Val Trompia",
        "Gargnano",
        "Gavardo",
        "Ghedi",
        "Gianico",
        "Gottolengo",
        "Gussago",
        "Idro",
        "Incudine",
        "Irma",
        "Iseo",
        "Isorella",
        "Lavenone",
        "Leno",
        "Limone sul Garda",
        "Lodrino",
        "Lograto",
        "Lonato del Garda",
        "Longhena",
        "Losine",
        "Lozio",
        "Lumezzane",
        "Maclodio",
        "Magasa",
        "Mairano",
        "Malegno",
        "Malonno",
        "Manerba del Garda",
        "Manerbio",
        "Marcheno",
        "Marmentino",
        "Marone",
        "Mazzano",
        "Milzano",
        "Moniga del Garda",
        "Monno",
        "Monte Isola",
        "Monticelli Brusati",
        "Montichiari",
        "Montirone",
        "Mura",
        "Muscoline",
        "Nave",
        "Niardo",
        "Nuvolento",
        "Nuvolera",
        "Odolo",
        "Offlaga",
        "Ome",
        "Ono San Pietro",
        "Orzinuovi",
        "Orzivecchi",
        "Ospitaletto",
        "Ossimo",
        "Padenghe sul Garda",
        "Paderno Franciacorta",
        "Paisco Loveno",
        "Paitone",
        "Palazzolo sull\u0027Oglio",
        "Paratico",
        "Paspardo",
        "Passirano",
        "Pavone del Mella",
        "San Paolo",
        "Pertica Alta",
        "Pertica Bassa",
        "Pezzaze",
        "Pian Camuno",
        "Pisogne",
        "Polaveno",
        "Polpenazze del Garda",
        "Pompiano",
        "Poncarale",
        "Ponte di Legno",
        "Pontevico",
        "Pontoglio",
        "Pozzolengo",
        "Pralboino",
        "Preseglie",
        "Prevalle",
        "Provaglio d\u0027Iseo",
        "Provaglio Val Sabbia",
        "Puegnago del Garda",
        "Quinzano d\u0027Oglio",
        "Remedello",
        "Rezzato",
        "Roccafranca",
        "Rodengo Saiano",
        "Roè Volciano",
        "Roncadelle",
        "Rovato",
        "Rudiano",
        "Sabbio Chiese",
        "Sale Marasino",
        "Salò",
        "San Felice del Benaco",
        "San Gervasio Bresciano",
        "San Zeno Naviglio",
        "Sarezzo",
        "Saviore dell\u0027Adamello",
        "Sellero",
        "Seniga",
        "Serle",
        "Sirmione",
        "Soiano del Lago",
        "Sonico",
        "Sulzano",
        "Tavernole sul Mella",
        "Temù",
        "Tignale",
        "Torbole Casaglia",
        "Toscolano-Maderno",
        "Travagliato",
        "Tremosine sul Garda",
        "Trenzano",
        "Treviso Bresciano",
        "Urago d\u0027Oglio",
        "Vallio Terme",
        "Valvestino",
        "Verolanuova",
        "Verolavecchia",
        "Vestone",
        "Vezza d\u0027Oglio",
        "Villa Carcina",
        "Villachiara",
        "Villanuova sul Clisi",
        "Vione",
        "Visano",
        "Vobarno",
        "Zone",
        "Piancogno"
    ]],
    ["BT", [
        "Andria",
        "Barletta",
        "Bisceglie",
        "Canosa di Puglia",
        "Margherita di Savoia",
        "Minervino Murge",
        "San Ferdinando di Puglia",
        "Spinazzola",
        "Trani",
        "Trinitapoli"
    ]],
    ["SI", [
        "Abbadia San Salvatore",
        "Asciano",
        "Buonconvento",
        "Casole d\u0027Elsa",
        "Castellina in Chianti",
        "Castelnuovo Berardenga",
        "Castiglione d\u0027Orcia",
        "Cetona",
        "Chianciano Terme",
        "Chiusdino",
        "Chiusi",
        "Colle di Val d\u0027Elsa",
        "Gaiole in Chianti",
        "Montepulciano",
        "Monteriggioni",
        "Monteroni d\u0027Arbia",
        "Monticiano",
        "Murlo",
        "Piancastagnaio",
        "Pienza",
        "Poggibonsi",
        "Radda in Chianti",
        "Radicofani",
        "Radicondoli",
        "Rapolano Terme",
        "San Casciano dei Bagni",
        "San Gimignano",
        "San Quirico d\u0027Orcia",
        "Sarteano",
        "Siena",
        "Sinalunga",
        "Sovicille",
        "Torrita di Siena",
        "Trequanda",
        "Montalcino"
    ]],
    ["BZ", [
        "Aldino",
        "Andriano",
        "Anterivo",
        "Appiano sulla strada del vino",
        "Avelengo",
        "Badia",
        "Barbiano",
        "Bolzano",
        "Braies",
        "Brennero",
        "Bressanone",
        "Bronzolo",
        "Brunico",
        "Caines",
        "Caldaro sulla strada del vino",
        "Campo di Trens",
        "Campo Tures",
        "Castelbello-Ciardes",
        "Castelrotto",
        "Cermes",
        "Chienes",
        "Chiusa",
        "Cornedo all\u0027Isarco",
        "Cortaccia sulla strada del vino",
        "Cortina sulla strada del vino",
        "Corvara in Badia",
        "Curon Venosta",
        "Dobbiaco",
        "Egna",
        "Falzes",
        "Fiè allo Sciliar",
        "Fortezza",
        "Funes",
        "Gais",
        "Gargazzone",
        "Glorenza",
        "Laces",
        "Lagundo",
        "Laion",
        "Laives",
        "Lana",
        "Lasa",
        "Lauregno",
        "Luson",
        "Magrè sulla strada del vino",
        "Malles Venosta",
        "Marebbe",
        "Marlengo",
        "Martello",
        "Meltina",
        "Merano",
        "Monguelfo-Tesido",
        "Montagna sulla strada del vino",
        "Moso in Passiria",
        "Nalles",
        "Naturno",
        "Naz-Sciaves",
        "Nova Levante",
        "Nova Ponente",
        "Ora",
        "Ortisei",
        "Parcines",
        "Perca",
        "Plaus",
        "Ponte Gardena",
        "Postal",
        "Prato allo Stelvio",
        "Predoi",
        "Proves",
        "Racines",
        "Rasun-Anterselva",
        "Renon",
        "Rifiano",
        "Rio di Pusteria",
        "Rodengo",
        "Salorno sulla strada del vino",
        "San Candido",
        "San Genesio Atesino",
        "San Leonardo in Passiria",
        "San Lorenzo di Sebato",
        "San Martino in Badia",
        "San Martino in Passiria",
        "San Pancrazio",
        "Santa Cristina Valgardena",
        "Sarentino",
        "Scena",
        "Selva dei Molini",
        "Selva di Val Gardena",
        "Senales",
        "Sesto",
        "Silandro",
        "Sluderno",
        "Stelvio",
        "Terento",
        "Terlano",
        "Termeno sulla strada del vino",
        "Tesimo",
        "Tires",
        "Tirolo",
        "Trodena nel parco naturale",
        "Tubre",
        "Ultimo",
        "Vadena",
        "Valdaora",
        "Val di Vizze",
        "Valle Aurina",
        "Valle di Casies",
        "Vandoies",
        "Varna",
        "Verano",
        "Villabassa",
        "Villandro",
        "Vipiteno",
        "Velturno",
        "La Valle",
        "Senale-San Felice"
    ]],
    ["SO", [
        "Albaredo per San Marco",
        "Albosaggia",
        "Andalo Valtellino",
        "Aprica",
        "Ardenno",
        "Bema",
        "Berbenno di Valtellina",
        "Bianzone",
        "Bormio",
        "Buglio in Monte",
        "Caiolo",
        "Campodolcino",
        "Caspoggio",
        "Castello dell\u0027Acqua",
        "Castione Andevenno",
        "Cedrasco",
        "Cercino",
        "Chiavenna",
        "Chiesa in Valmalenco",
        "Chiuro",
        "Cino",
        "Civo",
        "Colorina",
        "Cosio Valtellino",
        "Dazio",
        "Delebio",
        "Dubino",
        "Faedo Valtellino",
        "Forcola",
        "Fusine",
        "Gerola Alta",
        "Gordona",
        "Grosio",
        "Grosotto",
        "Madesimo",
        "Lanzada",
        "Livigno",
        "Lovero",
        "Mantello",
        "Mazzo di Valtellina",
        "Mello",
        "Mese",
        "Montagna in Valtellina",
        "Morbegno",
        "Novate Mezzola",
        "Pedesina",
        "Piantedo",
        "Piateda",
        "Piuro",
        "Poggiridenti",
        "Ponte in Valtellina",
        "Postalesio",
        "Prata Camportaccio",
        "Rasura",
        "Rogolo",
        "Samolaco",
        "San Giacomo Filippo",
        "Sernio",
        "Sondalo",
        "Sondrio",
        "Spriana",
        "Talamona",
        "Tartano",
        "Teglio",
        "Tirano",
        "Torre di Santa Maria",
        "Tovo di Sant\u0027Agata",
        "Traona",
        "Tresivio",
        "Valdidentro",
        "Valdisotto",
        "Valfurva",
        "Val Masino",
        "Verceia",
        "Vervio",
        "Villa di Chiavenna",
        "Villa di Tirano"
    ]],
    ["SP", [
        "Ameglia",
        "Arcola",
        "Beverino",
        "Bolano",
        "Bonassola",
        "Borghetto di Vara",
        "Brugnato",
        "Calice al Cornoviglio",
        "Carro",
        "Carrodano",
        "Castelnuovo Magra",
        "Deiva Marina",
        "Follo",
        "Framura",
        "La Spezia",
        "Lerici",
        "Levanto",
        "Maissana",
        "Monterosso al Mare",
        "Luni",
        "Pignone",
        "Portovenere",
        "Riccò del Golfo di Spezia",
        "Riomaggiore",
        "Rocchetta di Vara",
        "Santo Stefano di Magra",
        "Sarzana",
        "Sesta Godano",
        "Varese Ligure",
        "Vernazza",
        "Vezzano Ligure",
        "Zignago"
    ]],
    ["CA", [
        "Assemini",
        "Cagliari",
        "Capoterra",
        "Decimomannu",
        "Maracalagonis",
        "Pula",
        "Quartu Sant\u0027Elena",
        "Sarroch",
        "Selargius",
        "Sestu",
        "Settimo San Pietro",
        "Sinnai",
        "Uta",
        "Villa San Pietro",
        "Quartucciu",
        "Elmas",
        "Monserrato"
    ]],
    ["SR", [
        "Augusta",
        "Avola",
        "Buccheri",
        "Buscemi",
        "Canicattini Bagni",
        "Carlentini",
        "Cassaro",
        "Ferla",
        "Floridia",
        "Francofonte",
        "Lentini",
        "Melilli",
        "Noto",
        "Pachino",
        "Palazzolo Acreide",
        "Rosolini",
        "Siracusa",
        "Solarino",
        "Sortino",
        "Portopalo di Capo Passero",
        "Priolo Gargallo"
    ]],
    ["CB", [
        "Acquaviva Collecroce",
        "Baranello",
        "Bojano",
        "Bonefro",
        "Busso",
        "Campobasso",
        "Campochiaro",
        "Campodipietra",
        "Campolieto",
        "Campomarino",
        "Casacalenda",
        "Casalciprano",
        "Castelbottaccio",
        "Castellino del Biferno",
        "Castelmauro",
        "Castropignano",
        "Cercemaggiore",
        "Cercepiccola",
        "Civitacampomarano",
        "Colle d\u0027Anchise",
        "Colletorto",
        "Duronia",
        "Ferrazzano",
        "Fossalto",
        "Gambatesa",
        "Gildone",
        "Guardialfiera",
        "Guardiaregia",
        "Guglionesi",
        "Jelsi",
        "Larino",
        "Limosano",
        "Lucito",
        "Lupara",
        "Macchia Valfortore",
        "Mafalda",
        "Matrice",
        "Mirabello Sannitico",
        "Molise",
        "Monacilioni",
        "Montagano",
        "Montecilfone",
        "Montefalcone nel Sannio",
        "Montelongo",
        "Montemitro",
        "Montenero di Bisaccia",
        "Montorio nei Frentani",
        "Morrone del Sannio",
        "Oratino",
        "Palata",
        "Petacciato",
        "Petrella Tifernina",
        "Pietracatella",
        "Pietracupa",
        "Portocannone",
        "Provvidenti",
        "Riccia",
        "Ripabottoni",
        "Ripalimosani",
        "Roccavivara",
        "Rotello",
        "Salcito",
        "San Biase",
        "San Felice del Molise",
        "San Giacomo degli Schiavoni",
        "San Giovanni in Galdo",
        "San Giuliano del Sannio",
        "San Giuliano di Puglia",
        "San Martino in Pensilis",
        "San Massimo",
        "San Polo Matese",
        "Santa Croce di Magliano",
        "Sant\u0027Angelo Limosano",
        "Sant\u0027Elia a Pianisi",
        "Sepino",
        "Spinete",
        "Tavenna",
        "Termoli",
        "Torella del Sannio",
        "Toro",
        "Trivento",
        "Tufara",
        "Ururi",
        "Vinchiaturo"
    ]],
    ["SS", [
        "Aggius",
        "Alà dei Sardi",
        "Alghero",
        "Anela",
        "Ardara",
        "Arzachena",
        "Banari",
        "Benetutti",
        "Berchidda",
        "Bessude",
        "Bonnanaro",
        "Bono",
        "Bonorva",
        "Bortigiadas",
        "Borutta",
        "Bottidda",
        "Buddusò",
        "Bultei",
        "Bulzi",
        "Burgos",
        "Calangianus",
        "Cargeghe",
        "Castelsardo",
        "Cheremule",
        "Chiaramonti",
        "Codrongianos",
        "Cossoine",
        "Esporlatu",
        "Florinas",
        "Giave",
        "Illorai",
        "Ittireddu",
        "Ittiri",
        "Laerru",
        "La Maddalena",
        "Luogosanto",
        "Luras",
        "Mara",
        "Martis",
        "Monteleone Rocca Doria",
        "Monti",
        "Mores",
        "Muros",
        "Nughedu San Nicolò",
        "Nule",
        "Nulvi",
        "Olbia",
        "Olmedo",
        "Oschiri",
        "Osilo",
        "Ossi",
        "Ozieri",
        "Padria",
        "Palau",
        "Pattada",
        "Perfugas",
        "Ploaghe",
        "Porto Torres",
        "Pozzomaggiore",
        "Putifigari",
        "Romana",
        "Aglientu",
        "Santa Teresa Gallura",
        "Sassari",
        "Sedini",
        "Semestene",
        "Sennori",
        "Siligo",
        "Sorso",
        "Tempio Pausania",
        "Thiesi",
        "Tissi",
        "Torralba",
        "Trinità d\u0027Agultu e Vignola",
        "Tula",
        "Uri",
        "Usini",
        "Villanova Monteleone",
        "Valledoria",
        "Telti",
        "Badesi",
        "Viddalba",
        "Golfo Aranci",
        "Loiri Porto San Paolo",
        "Sant\u0027Antonio di Gallura",
        "Tergu",
        "Santa Maria Coghinas",
        "Erula",
        "Stintino",
        "Padru",
        "Budoni",
        "San Teodoro"
    ]],
    ["SU", [
        "Arbus",
        "Armungia",
        "Ballao",
        "Barrali",
        "Barumini",
        "Buggerru",
        "Burcei",
        "Calasetta",
        "Carbonia",
        "Carloforte",
        "Castiadas",
        "Collinas",
        "Decimoputzu",
        "Dolianova",
        "Domus de Maria",
        "Domusnovas",
        "Donori",
        "Escalaplano",
        "Escolca",
        "Esterzili",
        "Fluminimaggiore",
        "Furtei",
        "Genoni",
        "Genuri",
        "Gergei",
        "Gesico",
        "Gesturi",
        "Giba",
        "Goni",
        "Gonnesa",
        "Gonnosfanadiga",
        "Guamaggiore",
        "Guasila",
        "Guspini",
        "Iglesias",
        "Isili",
        "Las Plassas",
        "Lunamatrona",
        "Mandas",
        "Masainas",
        "Monastir",
        "Muravera",
        "Musei",
        "Narcao",
        "Nuragus",
        "Nurallao",
        "Nuraminis",
        "Nurri",
        "Nuxis",
        "Orroli",
        "Ortacesus",
        "Pabillonis",
        "Pauli Arbarei",
        "Perdaxius",
        "Pimentel",
        "Piscinas",
        "Portoscuso",
        "Sadali",
        "Samassi",
        "Samatzai",
        "San Basilio",
        "San Gavino Monreale",
        "San Giovanni Suergiu",
        "San Nicolò Gerrei",
        "San Sperate",
        "San Vito",
        "Sanluri",
        "Santadi",
        "Sant\u0027Andrea Frius",
        "Sant\u0027Anna Arresi",
        "Sant\u0027Antioco",
        "Sardara",
        "Segariu",
        "Selegas",
        "Senorbì",
        "Serdiana",
        "Serramanna",
        "Serrenti",
        "Serri",
        "Setzu",
        "Seui",
        "Seulo",
        "Siddi",
        "Siliqua",
        "Silius",
        "Siurgus Donigala",
        "Soleminis",
        "Suelli",
        "Teulada",
        "Tratalias",
        "Tuili",
        "Turri",
        "Ussana",
        "Ussaramanna",
        "Vallermosa",
        "Villacidro",
        "Villamar",
        "Villamassargia",
        "Villanova Tulo",
        "Villanovaforru",
        "Villanovafranca",
        "Villaperuccio",
        "Villaputzu",
        "Villasalto",
        "Villasimius",
        "Villasor",
        "Villaspeciosa"
    ]],
    ["CE", [
        "Ailano",
        "Alife",
        "Alvignano",
        "Arienzo",
        "Aversa",
        "Baia e Latina",
        "Bellona",
        "Caianello",
        "Caiazzo",
        "Calvi Risorta",
        "Camigliano",
        "Cancello ed Arnone",
        "Capodrise",
        "Capriati a Volturno",
        "Capua",
        "Carinaro",
        "Carinola",
        "Casagiove",
        "Casal di Principe",
        "Casaluce",
        "Casapulla",
        "Caserta",
        "Castel Campagnano",
        "Castel di Sasso",
        "Castello del Matese",
        "Castel Morrone",
        "Castel Volturno",
        "Cervino",
        "Cesa",
        "Ciorlano",
        "Conca della Campania",
        "Curti",
        "Dragoni",
        "Fontegreca",
        "Formicola",
        "Francolise",
        "Frignano",
        "Gallo Matese",
        "Galluccio",
        "Giano Vetusto",
        "Gioia Sannitica",
        "Grazzanise",
        "Gricignano di Aversa",
        "Letino",
        "Liberi",
        "Lusciano",
        "Macerata Campania",
        "Maddaloni",
        "Marcianise",
        "Marzano Appio",
        "Mignano Monte Lungo",
        "Mondragone",
        "Orta di Atella",
        "Parete",
        "Pastorano",
        "Piana di Monte Verna",
        "Piedimonte Matese",
        "Pietramelara",
        "Pietravairano",
        "Pignataro Maggiore",
        "Pontelatone",
        "Portico di Caserta",
        "Prata Sannita",
        "Pratella",
        "Presenzano",
        "Raviscanina",
        "Recale",
        "Riardo",
        "Rocca d\u0027Evandro",
        "Roccamonfina",
        "Roccaromana",
        "Rocchetta e Croce",
        "Ruviano",
        "San Cipriano d\u0027Aversa",
        "San Felice a Cancello",
        "San Gregorio Matese",
        "San Marcellino",
        "San Nicola la Strada",
        "San Pietro Infine",
        "San Potito Sannitico",
        "San Prisco",
        "Santa Maria a Vico",
        "Santa Maria Capua Vetere",
        "Santa Maria la Fossa",
        "San Tammaro",
        "Sant\u0027Angelo d\u0027Alife",
        "Sant\u0027Arpino",
        "Sessa Aurunca",
        "Sparanise",
        "Succivo",
        "Teano",
        "Teverola",
        "Tora e Piccilli",
        "Trentola Ducenta",
        "Vairano Patenora",
        "Valle Agricola",
        "Valle di Maddaloni",
        "Villa di Briano",
        "Villa Literno",
        "Vitulazio",
        "Falciano del Massico",
        "Cellole",
        "Casapesenna",
        "San Marco Evangelista"
    ]],
    ["SV", [
        "Alassio",
        "Albenga",
        "Albissola Marina",
        "Albisola Superiore",
        "Altare",
        "Andora",
        "Arnasco",
        "Balestrino",
        "Bardineto",
        "Bergeggi",
        "Boissano",
        "Borghetto Santo Spirito",
        "Borgio Verezzi",
        "Bormida",
        "Cairo Montenotte",
        "Calice Ligure",
        "Calizzano",
        "Carcare",
        "Casanova Lerrone",
        "Castelbianco",
        "Castelvecchio di Rocca Barbena",
        "Celle Ligure",
        "Cengio",
        "Ceriale",
        "Cisano sul Neva",
        "Cosseria",
        "Dego",
        "Erli",
        "Finale Ligure",
        "Garlenda",
        "Giustenice",
        "Giusvalla",
        "Laigueglia",
        "Loano",
        "Magliolo",
        "Mallare",
        "Massimino",
        "Millesimo",
        "Mioglia",
        "Murialdo",
        "Nasino",
        "Noli",
        "Onzo",
        "Orco Feglino",
        "Ortovero",
        "Osiglia",
        "Pallare",
        "Piana Crixia",
        "Pietra Ligure",
        "Plodio",
        "Pontinvrea",
        "Quiliano",
        "Rialto",
        "Roccavignale",
        "Sassello",
        "Savona",
        "Spotorno",
        "Stella",
        "Stellanello",
        "Testico",
        "Toirano",
        "Tovo San Giacomo",
        "Urbe",
        "Vado Ligure",
        "Varazze",
        "Vendone",
        "Vezzi Portio",
        "Villanova d\u0027Albenga",
        "Zuccarello"
    ]],
    ["CH", [
        "Altino",
        "Archi",
        "Ari",
        "Arielli",
        "Atessa",
        "Bomba",
        "Borrello",
        "Bucchianico",
        "Montebello sul Sangro",
        "Canosa Sannita",
        "Carpineto Sinello",
        "Carunchio",
        "Casacanditella",
        "Casalanguida",
        "Casalbordino",
        "Casalincontrada",
        "Casoli",
        "Castel Frentano",
        "Castelguidone",
        "Castiglione Messer Marino",
        "Celenza sul Trigno",
        "Chieti",
        "Civitaluparella",
        "Civitella Messer Raimondo",
        "Colledimacine",
        "Colledimezzo",
        "Crecchio",
        "Cupello",
        "Dogliola",
        "Fara Filiorum Petri",
        "Fara San Martino",
        "Filetto",
        "Fossacesia",
        "Fraine",
        "Francavilla al Mare",
        "Fresagrandinaria",
        "Frisa",
        "Furci",
        "Gamberale",
        "Gessopalena",
        "Gissi",
        "Giuliano Teatino",
        "Guardiagrele",
        "Guilmi",
        "Lama dei Peligni",
        "Lanciano",
        "Lentella",
        "Lettopalena",
        "Liscia",
        "Miglianico",
        "Montazzoli",
        "Monteferrante",
        "Montelapiano",
        "Montenerodomo",
        "Monteodorisio",
        "Mozzagrogna",
        "Orsogna",
        "Ortona",
        "Paglieta",
        "Palena",
        "Palmoli",
        "Palombaro",
        "Pennadomo",
        "Pennapiedimonte",
        "Perano",
        "Pizzoferrato",
        "Poggiofiorito",
        "Pollutri",
        "Pretoro",
        "Quadri",
        "Rapino",
        "Ripa Teatina",
        "Roccamontepiano",
        "Rocca San Giovanni",
        "Roccascalegna",
        "Roccaspinalveti",
        "Roio del Sangro",
        "Rosello",
        "San Buono",
        "San Giovanni Lipioni",
        "San Giovanni Teatino",
        "San Martino sulla Marrucina",
        "San Salvo",
        "Santa Maria Imbaro",
        "Sant\u0027Eusanio del Sangro",
        "San Vito Chietino",
        "Scerni",
        "Schiavi di Abruzzo",
        "Taranta Peligna",
        "Tollo",
        "Torino di Sangro",
        "Tornareccio",
        "Torrebruna",
        "Torrevecchia Teatina",
        "Torricella Peligna",
        "Treglio",
        "Tufillo",
        "Vacri",
        "Vasto",
        "Villalfonsina",
        "Villamagna",
        "Villa Santa Maria",
        "Pietraferrazzana",
        "Fallo"
    ]],
    ["KR", [
        "Belvedere di Spinello",
        "Caccuri",
        "Carfizzi",
        "Casabona",
        "Castelsilano",
        "Cerenzia",
        "Cirò",
        "Cirò Marina",
        "Cotronei",
        "Crotone",
        "Crucoli",
        "Cutro",
        "Isola di Capo Rizzuto",
        "Melissa",
        "Mesoraca",
        "Pallagorio",
        "Petilia Policastro",
        "Roccabernarda",
        "Rocca di Neto",
        "San Mauro Marchesato",
        "San Nicola dell\u0027Alto",
        "Santa Severina",
        "Savelli",
        "Scandale",
        "Strongoli",
        "Umbriatico",
        "Verzino"
    ]],
    ["CL", [
        "Acquaviva Platani",
        "Bompensiere",
        "Butera",
        "Caltanissetta",
        "Campofranco",
        "Delia",
        "Gela",
        "Marianopoli",
        "Mazzarino",
        "Milena",
        "Montedoro",
        "Mussomeli",
        "Niscemi",
        "Resuttano",
        "Riesi",
        "San Cataldo",
        "Santa Caterina Villarmosa",
        "Serradifalco",
        "Sommatino",
        "Sutera",
        "Vallelunga Pratameno",
        "Villalba"
    ]],
    ["CN", [
        "Acceglio",
        "Aisone",
        "Alba",
        "Albaretto della Torre",
        "Alto",
        "Argentera",
        "Arguello",
        "Bagnasco",
        "Bagnolo Piemonte",
        "Baldissero d\u0027Alba",
        "Barbaresco",
        "Barge",
        "Barolo",
        "Bastia Mondovì",
        "Battifollo",
        "Beinette",
        "Bellino",
        "Belvedere Langhe",
        "Bene Vagienna",
        "Benevello",
        "Bergolo",
        "Bernezzo",
        "Bonvicino",
        "Borgomale",
        "Borgo San Dalmazzo",
        "Bosia",
        "Bossolasco",
        "Boves",
        "Bra",
        "Briaglia",
        "Briga Alta",
        "Brondello",
        "Brossasco",
        "Busca",
        "Camerana",
        "Canale",
        "Canosio",
        "Caprauna",
        "Caraglio",
        "Caramagna Piemonte",
        "Cardè",
        "Carrù",
        "Cartignano",
        "Casalgrasso",
        "Castagnito",
        "Casteldelfino",
        "Castelletto Stura",
        "Castelletto Uzzone",
        "Castellinaldo d\u0027Alba",
        "Castellino Tanaro",
        "Castelmagno",
        "Castelnuovo di Ceva",
        "Castiglione Falletto",
        "Castiglione Tinella",
        "Castino",
        "Cavallerleone",
        "Cavallermaggiore",
        "Celle di Macra",
        "Centallo",
        "Ceresole Alba",
        "Cerretto Langhe",
        "Cervasca",
        "Cervere",
        "Ceva",
        "Cherasco",
        "Chiusa di Pesio",
        "Cigliè",
        "Cissone",
        "Clavesana",
        "Corneliano d\u0027Alba",
        "Cortemilia",
        "Cossano Belbo",
        "Costigliole Saluzzo",
        "Cravanzana",
        "Crissolo",
        "Cuneo",
        "Demonte",
        "Diano d\u0027Alba",
        "Dogliani",
        "Dronero",
        "Elva",
        "Entracque",
        "Envie",
        "Farigliano",
        "Faule",
        "Feisoglio",
        "Fossano",
        "Frabosa Soprana",
        "Frabosa Sottana",
        "Frassino",
        "Gaiola",
        "Gambasca",
        "Garessio",
        "Genola",
        "Gorzegno",
        "Gottasecca",
        "Govone",
        "Grinzane Cavour",
        "Guarene",
        "Igliano",
        "Isasca",
        "Lagnasco",
        "La Morra",
        "Lequio Berria",
        "Lequio Tanaro",
        "Lesegno",
        "Levice",
        "Limone Piemonte",
        "Lisio",
        "Macra",
        "Magliano Alfieri",
        "Magliano Alpi",
        "Mango",
        "Manta",
        "Marene",
        "Margarita",
        "Marmora",
        "Marsaglia",
        "Martiniana Po",
        "Melle",
        "Moiola",
        "Mombarcaro",
        "Mombasiglio",
        "Monastero di Vasco",
        "Monasterolo Casotto",
        "Monasterolo di Savigliano",
        "Monchiero",
        "Mondovì",
        "Monesiglio",
        "Monforte d\u0027Alba",
        "Montà",
        "Montaldo di Mondovì",
        "Montaldo Roero",
        "Montanera",
        "Montelupo Albese",
        "Montemale di Cuneo",
        "Monterosso Grana",
        "Monteu Roero",
        "Montezemolo",
        "Monticello d\u0027Alba",
        "Moretta",
        "Morozzo",
        "Murazzano",
        "Murello",
        "Narzole",
        "Neive",
        "Neviglie",
        "Niella Belbo",
        "Niella Tanaro",
        "Novello",
        "Nucetto",
        "Oncino",
        "Ormea",
        "Ostana",
        "Paesana",
        "Pagno",
        "Pamparato",
        "Paroldo",
        "Perletto",
        "Perlo",
        "Peveragno",
        "Pezzolo Valle Uzzone",
        "Pianfei",
        "Piasco",
        "Pietraporzio",
        "Piobesi d\u0027Alba",
        "Piozzo",
        "Pocapaglia",
        "Polonghera",
        "Pontechianale",
        "Pradleves",
        "Prazzo",
        "Priero",
        "Priocca",
        "Priola",
        "Prunetto",
        "Racconigi",
        "Revello",
        "Rifreddo",
        "Rittana",
        "Roaschia",
        "Roascio",
        "Robilante",
        "Roburent",
        "Roccabruna",
        "Rocca Cigliè",
        "Rocca de\u0027 Baldi",
        "Roccaforte Mondovì",
        "Roccasparvera",
        "Roccavione",
        "Rocchetta Belbo",
        "Roddi",
        "Roddino",
        "Rodello",
        "Rossana",
        "Ruffia",
        "Sale delle Langhe",
        "Sale San Giovanni",
        "Saliceto",
        "Salmour",
        "Saluzzo",
        "Sambuco",
        "Sampeyre",
        "San Benedetto Belbo",
        "San Damiano Macra",
        "Sanfrè",
        "Sanfront",
        "San Michele Mondovì",
        "Sant\u0027Albano Stura",
        "Santa Vittoria d\u0027Alba",
        "Santo Stefano Belbo",
        "Santo Stefano Roero",
        "Savigliano",
        "Scagnello",
        "Scarnafigi",
        "Serralunga d\u0027Alba",
        "Serravalle Langhe",
        "Sinio",
        "Somano",
        "Sommariva del Bosco",
        "Sommariva Perno",
        "Stroppo",
        "Tarantasca",
        "Torre Bormida",
        "Torre Mondovì",
        "Torre San Giorgio",
        "Torresina",
        "Treiso",
        "Trezzo Tinella",
        "Trinità",
        "Valdieri",
        "Valgrana",
        "Valloriate",
        "Venasca",
        "Verduno",
        "Vernante",
        "Verzuolo",
        "Vezza d\u0027Alba",
        "Vicoforte",
        "Vignolo",
        "Villafalletto",
        "Villanova Mondovì",
        "Villanova Solaro",
        "Villar San Costanzo",
        "Vinadio",
        "Viola",
        "Vottignasco"
    ]],
    ["CO", [
        "Albavilla",
        "Albese con Cassano",
        "Albiolo",
        "Alserio",
        "Alzate Brianza",
        "Anzano del Parco",
        "Appiano Gentile",
        "Argegno",
        "Arosio",
        "Asso",
        "Barni",
        "Bene Lario",
        "Beregazzo con Figliaro",
        "Binago",
        "Bizzarone",
        "Blessagno",
        "Blevio",
        "Bregnano",
        "Brenna",
        "Brienno",
        "Brunate",
        "Bulgarograsso",
        "Cabiate",
        "Cadorago",
        "Caglio",
        "Campione d\u0027Italia",
        "Cantù",
        "Canzo",
        "Capiago Intimiano",
        "Carate Urio",
        "Carbonate",
        "Carimate",
        "Carlazzo",
        "Carugo",
        "Caslino d\u0027Erba",
        "Casnate con Bernate",
        "Cassina Rizzardi",
        "Castelmarte",
        "Castelnuovo Bozzente",
        "Cavargna",
        "Cerano d\u0027Intelvi",
        "Cermenate",
        "Cernobbio",
        "Cirimido",
        "Claino con Osteno",
        "Colonno",
        "Como",
        "Corrido",
        "Cremia",
        "Cucciago",
        "Cusino",
        "Dizzasco",
        "Domaso",
        "Dongo",
        "Dosso del Liro",
        "Erba",
        "Eupilio",
        "Faggeto Lario",
        "Faloppio",
        "Fenegrò",
        "Figino Serenza",
        "Fino Mornasco",
        "Garzeno",
        "Gera Lario",
        "Grandate",
        "Grandola ed Uniti",
        "Griante",
        "Guanzate",
        "Inverigo",
        "Laglio",
        "Laino",
        "Lambrugo",
        "Lasnigo",
        "Lezzeno",
        "Limido Comasco",
        "Lipomo",
        "Livo",
        "Locate Varesino",
        "Lomazzo",
        "Longone al Segrino",
        "Luisago",
        "Lurago d\u0027Erba",
        "Lurago Marinone",
        "Lurate Caccivio",
        "Magreglio",
        "Mariano Comense",
        "Maslianico",
        "Menaggio",
        "Merone",
        "Moltrasio",
        "Monguzzo",
        "Montano Lucino",
        "Montemezzo",
        "Montorfano",
        "Mozzate",
        "Musso",
        "Nesso",
        "Novedrate",
        "Olgiate Comasco",
        "Oltrona di San Mamette",
        "Orsenigo",
        "Peglio",
        "Pianello del Lario",
        "Pigra",
        "Plesio",
        "Pognana Lario",
        "Ponna",
        "Ponte Lambro",
        "Porlezza",
        "Proserpio",
        "Pusiano",
        "Rezzago",
        "Rodero",
        "Rovellasca",
        "Rovello Porro",
        "Sala Comacina",
        "San Bartolomeo Val Cavargna",
        "San Fermo della Battaglia",
        "San Nazzaro Val Cavargna",
        "Schignano",
        "Senna Comasco",
        "Sorico",
        "Sormano",
        "Stazzona",
        "Tavernerio",
        "Torno",
        "Trezzone",
        "Turate",
        "Valbrona",
        "Valmorea",
        "Val Rezzo",
        "Valsolda",
        "Veleso",
        "Veniano",
        "Vercana",
        "Vertemate con Minoprio",
        "Villa Guardia",
        "Zelbio",
        "San Siro",
        "Gravedona ed Uniti",
        "Bellagio",
        "Colverde",
        "Tremezzina",
        "Alta Valle Intelvi",
        "Centro Valle Intelvi",
        "Solbiate con Cagno",
        "Uggiate con Ronago"
    ]],
    ["TA", [
        "Avetrana",
        "Carosino",
        "Castellaneta",
        "Crispiano",
        "Faggiano",
        "Fragagnano",
        "Ginosa",
        "Grottaglie",
        "Laterza",
        "Leporano",
        "Lizzano",
        "Manduria",
        "Martina Franca",
        "Maruggio",
        "Massafra",
        "Monteiasi",
        "Montemesola",
        "Monteparano",
        "Mottola",
        "Palagianello",
        "Palagiano",
        "Pulsano",
        "Roccaforzata",
        "San Giorgio Ionico",
        "San Marzano di San Giuseppe",
        "Sava",
        "Taranto",
        "Torricella",
        "Statte"
    ]],
    ["CR", [
        "Acquanegra Cremonese",
        "Agnadello",
        "Annicco",
        "Azzanello",
        "Bagnolo Cremasco",
        "Bonemerse",
        "Bordolano",
        "Calvatone",
        "Camisano",
        "Campagnola Cremasca",
        "Capergnanica",
        "Cappella Cantone",
        "Cappella de\u0027 Picenardi",
        "Capralba",
        "Casalbuttano ed Uniti",
        "Casale Cremasco-Vidolasco",
        "Casaletto Ceredano",
        "Casaletto di Sopra",
        "Casaletto Vaprio",
        "Casalmaggiore",
        "Casalmorano",
        "Casteldidone",
        "Castel Gabbiano",
        "Castelleone",
        "Castelverde",
        "Castelvisconti",
        "Cella Dati",
        "Chieve",
        "Cicognolo",
        "Cingia de\u0027 Botti",
        "Corte de\u0027 Cortesi con Cignone",
        "Corte de\u0027 Frati",
        "Credera Rubbiano",
        "Crema",
        "Cremona",
        "Cremosano",
        "Crotta d\u0027Adda",
        "Cumignano sul Naviglio",
        "Derovere",
        "Dovera",
        "Fiesco",
        "Formigara",
        "Gabbioneta-Binanuova",
        "Gadesco-Pieve Delmona",
        "Genivolta",
        "Gerre de\u0027 Caprioli",
        "Gombito",
        "Grontardo",
        "Grumello Cremonese ed Uniti",
        "Gussola",
        "Isola Dovarese",
        "Izano",
        "Madignano",
        "Malagnino",
        "Martignana di Po",
        "Monte Cremasco",
        "Montodine",
        "Moscazzano",
        "Motta Baluffi",
        "Offanengo",
        "Olmeneta",
        "Ostiano",
        "Paderno Ponchielli",
        "Palazzo Pignano",
        "Pandino",
        "Persico Dosimo",
        "Pescarolo ed Uniti",
        "Pessina Cremonese",
        "Pianengo",
        "Pieranica",
        "Pieve d\u0027Olmi",
        "Pieve San Giacomo",
        "Pizzighettone",
        "Pozzaglio ed Uniti",
        "Quintano",
        "Ricengo",
        "Ripalta Arpina",
        "Ripalta Cremasca",
        "Ripalta Guerina",
        "Rivarolo del Re ed Uniti",
        "Rivolta d\u0027Adda",
        "Robecco d\u0027Oglio",
        "Romanengo",
        "Salvirola",
        "San Bassano",
        "San Daniele Po",
        "San Giovanni in Croce",
        "San Martino del Lago",
        "Scandolara Ravara",
        "Scandolara Ripa d\u0027Oglio",
        "Sergnano",
        "Sesto ed Uniti",
        "Solarolo Rainerio",
        "Soncino",
        "Soresina",
        "Sospiro",
        "Spinadesco",
        "Spineda",
        "Spino d\u0027Adda",
        "Stagno Lombardo",
        "Ticengo",
        "Torlino Vimercati",
        "Tornata",
        "Torre de\u0027 Picenardi",
        "Torricella del Pizzo",
        "Trescore Cremasco",
        "Trigolo",
        "Vaiano Cremasco",
        "Vailate",
        "Vescovato",
        "Volongo",
        "Voltido",
        "Piadena Drizzona"
    ]],
    ["CS", [
        "Acquaformosa",
        "Acquappesa",
        "Acri",
        "Aiello Calabro",
        "Aieta",
        "Albidona",
        "Alessandria del Carretto",
        "Altilia",
        "Altomonte",
        "Amantea",
        "Amendolara",
        "Aprigliano",
        "Belmonte Calabro",
        "Belsito",
        "Belvedere Marittimo",
        "Bianchi",
        "Bisignano",
        "Bocchigliero",
        "Bonifati",
        "Buonvicino",
        "Calopezzati",
        "Caloveto",
        "Campana",
        "Canna",
        "Cariati",
        "Carolei",
        "Carpanzano",
        "Cassano all\u0027Ionio",
        "Castiglione Cosentino",
        "Castrolibero",
        "Castroregio",
        "Castrovillari",
        "Celico",
        "Cellara",
        "Cerchiara di Calabria",
        "Cerisano",
        "Cervicati",
        "Cerzeto",
        "Cetraro",
        "Civita",
        "Cleto",
        "Colosimi",
        "Cosenza",
        "Cropalati",
        "Crosia",
        "Diamante",
        "Dipignano",
        "Domanico",
        "Fagnano Castello",
        "Falconara Albanese",
        "Figline Vegliaturo",
        "Firmo",
        "Fiumefreddo Bruzio",
        "Francavilla Marittima",
        "Frascineto",
        "Fuscaldo",
        "Grimaldi",
        "Grisolia",
        "Guardia Piemontese",
        "Lago",
        "Laino Borgo",
        "Laino Castello",
        "Lappano",
        "Lattarico",
        "Longobardi",
        "Longobucco",
        "Lungro",
        "Luzzi",
        "Maierà",
        "Malito",
        "Malvito",
        "Mandatoriccio",
        "Mangone",
        "Marano Marchesato",
        "Marano Principato",
        "Marzi",
        "Mendicino",
        "Mongrassano",
        "Montalto Uffugo",
        "Montegiordano",
        "Morano Calabro",
        "Mormanno",
        "Mottafollone",
        "Nocara",
        "Oriolo",
        "Orsomarso",
        "Paludi",
        "Panettieri",
        "Paola",
        "Papasidero",
        "Parenti",
        "Paterno Calabro",
        "Pedivigliano",
        "Piane Crati",
        "Pietrafitta",
        "Pietrapaola",
        "Plataci",
        "Praia a Mare",
        "Rende",
        "Rocca Imperiale",
        "Roggiano Gravina",
        "Rogliano",
        "Rose",
        "Roseto Capo Spulico",
        "Rota Greca",
        "Rovito",
        "San Basile",
        "San Benedetto Ullano",
        "San Cosmo Albanese",
        "San Demetrio Corone",
        "San Donato di Ninea",
        "San Fili",
        "Sangineto",
        "San Giorgio Albanese",
        "San Giovanni in Fiore",
        "San Lorenzo Bellizzi",
        "San Lorenzo del Vallo",
        "San Lucido",
        "San Marco Argentano",
        "San Martino di Finita",
        "San Nicola Arcella",
        "San Pietro in Amantea",
        "San Pietro in Guarano",
        "San Sosti",
        "Santa Caterina Albanese",
        "Santa Domenica Talao",
        "Sant\u0027Agata di Esaro",
        "Santa Maria del Cedro",
        "Santa Sofia d\u0027Epiro",
        "Santo Stefano di Rogliano",
        "San Vincenzo La Costa",
        "Saracena",
        "Scala Coeli",
        "Scalea",
        "Scigliano",
        "Serra d\u0027Aiello",
        "Spezzano Albanese",
        "Spezzano della Sila",
        "Tarsia",
        "Terranova da Sibari",
        "Terravecchia",
        "Torano Castello",
        "Tortora",
        "Trebisacce",
        "Vaccarizzo Albanese",
        "Verbicaro",
        "Villapiana",
        "Zumpano",
        "Casali del Manco",
        "Corigliano-Rossano"
    ]],
    ["CT", [
        "Aci Bonaccorsi",
        "Aci Castello",
        "Aci Catena",
        "Acireale",
        "Aci Sant\u0027Antonio",
        "Adrano",
        "Belpasso",
        "Biancavilla",
        "Bronte",
        "Calatabiano",
        "Caltagirone",
        "Camporotondo Etneo",
        "Castel di Iudica",
        "Castiglione di Sicilia",
        "Catania",
        "Fiumefreddo di Sicilia",
        "Giarre",
        "Grammichele",
        "Gravina di Catania",
        "Licodia Eubea",
        "Linguaglossa",
        "Maletto",
        "Mascali",
        "Mascalucia",
        "Militello in Val di Catania",
        "Milo",
        "Mineo",
        "Mirabella Imbaccari",
        "Misterbianco",
        "Motta Sant\u0027Anastasia",
        "Nicolosi",
        "Palagonia",
        "Paternò",
        "Pedara",
        "Piedimonte Etneo",
        "Raddusa",
        "Ramacca",
        "Randazzo",
        "Riposto",
        "San Cono",
        "San Giovanni la Punta",
        "San Gregorio di Catania",
        "San Michele di Ganzaria",
        "San Pietro Clarenza",
        "Sant\u0027Agata li Battiati",
        "Sant\u0027Alfio",
        "Santa Maria di Licodia",
        "Santa Venerina",
        "Scordia",
        "Trecastagni",
        "Tremestieri Etneo",
        "Valverde",
        "Viagrande",
        "Vizzini",
        "Zafferana Etnea",
        "Mazzarrone",
        "Maniace",
        "Ragalna"
    ]],
    ["TE", [
        "Alba Adriatica",
        "Ancarano",
        "Arsita",
        "Atri",
        "Basciano",
        "Bellante",
        "Bisenti",
        "Campli",
        "Canzano",
        "Castel Castagna",
        "Castellalto",
        "Castelli",
        "Castiglione Messer Raimondo",
        "Castilenti",
        "Cellino Attanasio",
        "Cermignano",
        "Civitella del Tronto",
        "Colledara",
        "Colonnella",
        "Controguerra",
        "Corropoli",
        "Cortino",
        "Crognaleto",
        "Fano Adriano",
        "Giulianova",
        "Isola del Gran Sasso d\u0027Italia",
        "Montefino",
        "Montorio al Vomano",
        "Morro d\u0027Oro",
        "Mosciano Sant\u0027Angelo",
        "Nereto",
        "Notaresco",
        "Penna Sant\u0027Andrea",
        "Pietracamela",
        "Pineto",
        "Rocca Santa Maria",
        "Roseto degli Abruzzi",
        "Sant\u0027Egidio alla Vibrata",
        "Sant\u0027Omero",
        "Silvi",
        "Teramo",
        "Torano Nuovo",
        "Torricella Sicura",
        "Tortoreto",
        "Tossicia",
        "Valle Castellana",
        "Martinsicuro"
    ]],
    ["CZ", [
        "Albi",
        "Amaroni",
        "Amato",
        "Andali",
        "Argusto",
        "Badolato",
        "Belcastro",
        "Borgia",
        "Botricello",
        "Caraffa di Catanzaro",
        "Cardinale",
        "Carlopoli",
        "Catanzaro",
        "Cenadi",
        "Centrache",
        "Cerva",
        "Chiaravalle Centrale",
        "Cicala",
        "Conflenti",
        "Cortale",
        "Cropani",
        "Curinga",
        "Davoli",
        "Decollatura",
        "Falerna",
        "Feroleto Antico",
        "Fossato Serralta",
        "Gagliato",
        "Gasperina",
        "Gimigliano",
        "Girifalco",
        "Gizzeria",
        "Guardavalle",
        "Isca sullo Ionio",
        "Jacurso",
        "Magisano",
        "Maida",
        "Marcedusa",
        "Marcellinara",
        "Martirano",
        "Martirano Lombardo",
        "Miglierina",
        "Montauro",
        "Montepaone",
        "Motta Santa Lucia",
        "Nocera Terinese",
        "Olivadi",
        "Palermiti",
        "Pentone",
        "Petrizzi",
        "Petronà",
        "Pianopoli",
        "Platania",
        "San Floro",
        "San Mango d\u0027Aquino",
        "San Pietro a Maida",
        "San Pietro Apostolo",
        "San Sostene",
        "Santa Caterina dello Ionio",
        "Sant\u0027Andrea Apostolo dello Ionio",
        "San Vito sullo Ionio",
        "Satriano",
        "Sellia",
        "Sellia Marina",
        "Serrastretta",
        "Sersale",
        "Settingiano",
        "Simeri Crichi",
        "Sorbo San Basile",
        "Soverato",
        "Soveria Mannelli",
        "Soveria Simeri",
        "Squillace",
        "Stalettì",
        "Taverna",
        "Tiriolo",
        "Torre di Ruggiero",
        "Vallefiorita",
        "Zagarise",
        "Lamezia Terme"
    ]],
    ["LC", [
        "Abbadia Lariana",
        "Airuno",
        "Annone di Brianza",
        "Ballabio",
        "Barzago",
        "Barzanò",
        "Barzio",
        "Bellano",
        "Bosisio Parini",
        "Brivio",
        "Bulciago",
        "Calco",
        "Calolziocorte",
        "Carenno",
        "Casargo",
        "Casatenovo",
        "Cassago Brianza",
        "Cassina Valsassina",
        "Castello di Brianza",
        "Cernusco Lombardone",
        "Cesana Brianza",
        "Civate",
        "Colico",
        "Colle Brianza",
        "Cortenova",
        "Costa Masnaga",
        "Crandola Valsassina",
        "Cremella",
        "Cremeno",
        "Dervio",
        "Dolzago",
        "Dorio",
        "Ello",
        "Erve",
        "Esino Lario",
        "Galbiate",
        "Garbagnate Monastero",
        "Garlate",
        "Imbersago",
        "Introbio",
        "Lecco",
        "Lierna",
        "Lomagna",
        "Malgrate",
        "Mandello del Lario",
        "Margno",
        "Merate",
        "Missaglia",
        "Moggio",
        "Molteno",
        "Monte Marenzo",
        "Montevecchia",
        "Monticello Brianza",
        "Morterone",
        "Nibionno",
        "Oggiono",
        "Olgiate Molgora",
        "Olginate",
        "Oliveto Lario",
        "Osnago",
        "Paderno d\u0027Adda",
        "Pagnona",
        "Parlasco",
        "Pasturo",
        "Perledo",
        "Pescate",
        "Premana",
        "Primaluna",
        "Robbiate",
        "Rogeno",
        "Santa Maria Hoè",
        "Sirone",
        "Sirtori",
        "Sueglio",
        "Suello",
        "Taceno",
        "Valgreghentino",
        "Valmadrera",
        "Varenna",
        "Vercurago",
        "Viganò",
        "Verderio",
        "La Valletta Brianza",
        "Valvarrone"
    ]],
    ["LE", [
        "Alessano",
        "Alezio",
        "Alliste",
        "Andrano",
        "Aradeo",
        "Arnesano",
        "Bagnolo del Salento",
        "Botrugno",
        "Calimera",
        "Campi Salentina",
        "Cannole",
        "Caprarica di Lecce",
        "Carmiano",
        "Carpignano Salentino",
        "Casarano",
        "Castri di Lecce",
        "Castrignano de\u0027 Greci",
        "Castrignano del Capo",
        "Cavallino",
        "Collepasso",
        "Copertino",
        "Corigliano d\u0027Otranto",
        "Corsano",
        "Cursi",
        "Cutrofiano",
        "Diso",
        "Gagliano del Capo",
        "Galatina",
        "Galatone",
        "Gallipoli",
        "Giuggianello",
        "Giurdignano",
        "Guagnano",
        "Lecce",
        "Lequile",
        "Leverano",
        "Lizzanello",
        "Maglie",
        "Martano",
        "Martignano",
        "Matino",
        "Melendugno",
        "Melissano",
        "Melpignano",
        "Miggiano",
        "Minervino di Lecce",
        "Monteroni di Lecce",
        "Montesano Salentino",
        "Morciano di Leuca",
        "Muro Leccese",
        "Nardò",
        "Neviano",
        "Nociglia",
        "Novoli",
        "Ortelle",
        "Otranto",
        "Palmariggi",
        "Parabita",
        "Patù",
        "Poggiardo",
        "Racale",
        "Ruffano",
        "Salice Salentino",
        "Salve",
        "Sanarica",
        "San Cesario di Lecce",
        "San Donato di Lecce",
        "Sannicola",
        "San Pietro in Lama",
        "Santa Cesarea Terme",
        "Scorrano",
        "Seclì",
        "Sogliano Cavour",
        "Soleto",
        "Specchia",
        "Spongano",
        "Squinzano",
        "Sternatia",
        "Supersano",
        "Surano",
        "Surbo",
        "Taurisano",
        "Taviano",
        "Tiggiano",
        "Trepuzzi",
        "Tricase",
        "Tuglie",
        "Ugento",
        "Uggiano la Chiesa",
        "Veglie",
        "Vernole",
        "Zollino",
        "San Cassiano",
        "Castro",
        "Porto Cesareo",
        "Presicce-Acquarica"
    ]],
    ["TN", [
        "Ala",
        "Albiano",
        "Aldeno",
        "Andalo",
        "Arco",
        "Avio",
        "Baselga di Pinè",
        "Bedollo",
        "Besenello",
        "Bieno",
        "Bleggio Superiore",
        "Bocenago",
        "Bondone",
        "Borgo Valsugana",
        "Brentonico",
        "Bresimo",
        "Caderzone Terme",
        "Calceranica al Lago",
        "Caldes",
        "Caldonazzo",
        "Calliano",
        "Campitello di Fassa",
        "Campodenno",
        "Canal San Bovo",
        "Canazei",
        "Capriana",
        "Carisolo",
        "Carzano",
        "Castel Condino",
        "Castello-Molina di Fiemme",
        "Castello Tesino",
        "Castelnuovo",
        "Cavalese",
        "Cavareno",
        "Cavedago",
        "Cavedine",
        "Cavizzana",
        "Cimone",
        "Cinte Tesino",
        "Cis",
        "Civezzano",
        "Cles",
        "Commezzadura",
        "Croviana",
        "Dambel",
        "Denno",
        "Drena",
        "Dro",
        "Fai della Paganella",
        "Fiavè",
        "Fierozzo",
        "Folgaria",
        "Fornace",
        "Frassilongo",
        "Garniga Terme",
        "Giovo",
        "Giustino",
        "Grigno",
        "Imer",
        "Isera",
        "Lavarone",
        "Lavis",
        "Levico Terme",
        "Livo",
        "Lona-Lases",
        "Luserna",
        "Malé",
        "Massimeno",
        "Mazzin",
        "Mezzana",
        "Mezzano",
        "Mezzocorona",
        "Mezzolombardo",
        "Moena",
        "Molveno",
        "Mori",
        "Nago-Torbole",
        "Nogaredo",
        "Nomi",
        "Novaledo",
        "Ospedaletto",
        "Ossana",
        "Palù del Fersina",
        "Panchià",
        "Ronzo-Chienis",
        "Peio",
        "Pellizzano",
        "Pelugo",
        "Pergine Valsugana",
        "Pieve Tesino",
        "Pinzolo",
        "Pomarolo",
        "Predazzo",
        "Rabbi",
        "Riva del Garda",
        "Romeno",
        "Roncegno Terme",
        "Ronchi Valsugana",
        "Ronzone",
        "Roverè della Luna",
        "Rovereto",
        "Ruffrè-Mendola",
        "Rumo",
        "Sagron Mis",
        "Samone",
        "San Michele all\u0027Adige",
        "Sant\u0027Orsola Terme",
        "Sanzeno",
        "Sarnonico",
        "Scurelle",
        "Segonzano",
        "Sfruz",
        "Soraga di Fassa",
        "Sover",
        "Spiazzo",
        "Spormaggiore",
        "Sporminore",
        "Stenico",
        "Storo",
        "Strembo",
        "Telve",
        "Telve di Sopra",
        "Tenna",
        "Tenno",
        "Terragnolo",
        "Terzolas",
        "Tesero",
        "Tione di Trento",
        "Ton",
        "Torcegno",
        "Trambileno",
        "Trento",
        "Valfloriana",
        "Vallarsa",
        "Vermiglio",
        "Vignola-Falesina",
        "Villa Lagarina",
        "Volano",
        "Ziano di Fiemme",
        "Comano Terme",
        "Ledro",
        "Predaia",
        "San Lorenzo Dorsino",
        "Valdaone",
        "Dimaro Folgarida",
        "Pieve di Bono-Prezzo",
        "Altavalle",
        "Altopiano della Vigolana",
        "Amblar-Don",
        "Borgo Chiese",
        "Borgo Lares",
        "Castel Ivano",
        "Cembra Lisignago",
        "Contà",
        "Madruzzo",
        "Porte di Rendena",
        "Primiero San Martino di Castrozza",
        "Sella Giudicarie",
        "Tre Ville",
        "Vallelaghi",
        "Ville d\u0027Anaunia",
        "San Giovanni di Fassa",
        "Terre d\u0027Adige",
        "Borgo d\u0027Anaunia",
        "Novella",
        "Ville di Fiemme"
    ]],
    ["TO", [
        "Agliè",
        "Airasca",
        "Ala di Stura",
        "Albiano d\u0027Ivrea",
        "Almese",
        "Alpette",
        "Alpignano",
        "Andezeno",
        "Andrate",
        "Angrogna",
        "Arignano",
        "Avigliana",
        "Azeglio",
        "Bairo",
        "Balangero",
        "Baldissero Canavese",
        "Baldissero Torinese",
        "Balme",
        "Banchette",
        "Barbania",
        "Bardonecchia",
        "Barone Canavese",
        "Beinasco",
        "Bibiana",
        "Bobbio Pellice",
        "Bollengo",
        "Borgaro Torinese",
        "Borgiallo",
        "Borgofranco d\u0027Ivrea",
        "Borgomasino",
        "Borgone Susa",
        "Bosconero",
        "Brandizzo",
        "Bricherasio",
        "Brosso",
        "Brozolo",
        "Bruino",
        "Brusasco",
        "Bruzolo",
        "Buriasco",
        "Burolo",
        "Busano",
        "Bussoleno",
        "Buttigliera Alta",
        "Cafasse",
        "Caluso",
        "Cambiano",
        "Campiglione Fenile",
        "Candia Canavese",
        "Candiolo",
        "Canischio",
        "Cantalupa",
        "Cantoira",
        "Caprie",
        "Caravino",
        "Carema",
        "Carignano",
        "Carmagnola",
        "Casalborgone",
        "Cascinette d\u0027Ivrea",
        "Caselette",
        "Caselle Torinese",
        "Castagneto Po",
        "Castagnole Piemonte",
        "Castellamonte",
        "Castelnuovo Nigra",
        "Castiglione Torinese",
        "Cavagnolo",
        "Cavour",
        "Cercenasco",
        "Ceres",
        "Ceresole Reale",
        "Cesana Torinese",
        "Chialamberto",
        "Chianocco",
        "Chiaverano",
        "Chieri",
        "Chiesanuova",
        "Chiomonte",
        "Chiusa di San Michele",
        "Chivasso",
        "Ciconio",
        "Cintano",
        "Cinzano",
        "Ciriè",
        "Claviere",
        "Coassolo Torinese",
        "Coazze",
        "Collegno",
        "Colleretto Castelnuovo",
        "Colleretto Giacosa",
        "Condove",
        "Corio",
        "Cossano Canavese",
        "Cuceglio",
        "Cumiana",
        "Cuorgnè",
        "Druento",
        "Exilles",
        "Favria",
        "Feletto",
        "Fenestrelle",
        "Fiano",
        "Fiorano Canavese",
        "Foglizzo",
        "Forno Canavese",
        "Frassinetto",
        "Front",
        "Frossasco",
        "Garzigliana",
        "Gassino Torinese",
        "Germagnano",
        "Giaglione",
        "Giaveno",
        "Givoletto",
        "Gravere",
        "Groscavallo",
        "Grosso",
        "Grugliasco",
        "Ingria",
        "Inverso Pinasca",
        "Isolabella",
        "Issiglio",
        "Ivrea",
        "La Cassa",
        "La Loggia",
        "Lanzo Torinese",
        "Lauriano",
        "Leini",
        "Lemie",
        "Lessolo",
        "Levone",
        "Locana",
        "Lombardore",
        "Lombriasco",
        "Loranzè",
        "Luserna San Giovanni",
        "Lusernetta",
        "Lusigliè",
        "Macello",
        "Maglione",
        "Marentino",
        "Massello",
        "Mathi",
        "Mattie",
        "Mazzè",
        "Meana di Susa",
        "Mercenasco",
        "Mezzenile",
        "Mombello di Torino",
        "Mompantero",
        "Monastero di Lanzo",
        "Moncalieri",
        "Moncenisio",
        "Montaldo Torinese",
        "Montalenghe",
        "Montalto Dora",
        "Montanaro",
        "Monteu da Po",
        "Moriondo Torinese",
        "Nichelino",
        "Noasca",
        "Nole",
        "Nomaglio",
        "None",
        "Novalesa",
        "Oglianico",
        "Orbassano",
        "Orio Canavese",
        "Osasco",
        "Osasio",
        "Oulx",
        "Ozegna",
        "Palazzo Canavese",
        "Pancalieri",
        "Parella",
        "Pavarolo",
        "Pavone Canavese",
        "Pecetto Torinese",
        "Perosa Argentina",
        "Perosa Canavese",
        "Perrero",
        "Pertusio",
        "Pessinetto",
        "Pianezza",
        "Pinasca",
        "Pinerolo",
        "Pino Torinese",
        "Piobesi Torinese",
        "Piossasco",
        "Piscina",
        "Piverone",
        "Poirino",
        "Pomaretto",
        "Pont Canavese",
        "Porte",
        "Pragelato",
        "Prali",
        "Pralormo",
        "Pramollo",
        "Prarostino",
        "Prascorsano",
        "Pratiglione",
        "Quagliuzzo",
        "Quassolo",
        "Quincinetto",
        "Reano",
        "Ribordone",
        "Rivalba",
        "Rivalta di Torino",
        "Riva presso Chieri",
        "Rivara",
        "Rivarolo Canavese",
        "Rivarossa",
        "Rivoli",
        "Robassomero",
        "Rocca Canavese",
        "Roletto",
        "Romano Canavese",
        "Ronco Canavese",
        "Rondissone",
        "Rorà",
        "Roure",
        "Rosta",
        "Rubiana",
        "Rueglio",
        "Salassa",
        "Salbertrand",
        "Salerano Canavese",
        "Salza di Pinerolo",
        "Samone",
        "San Benigno Canavese",
        "San Carlo Canavese",
        "San Colombano Belmonte",
        "San Didero",
        "San Francesco al Campo",
        "Sangano",
        "San Germano Chisone",
        "San Gillio",
        "San Giorgio Canavese",
        "San Giorio di Susa",
        "San Giusto Canavese",
        "San Martino Canavese",
        "San Maurizio Canavese",
        "San Mauro Torinese",
        "San Pietro Val Lemina",
        "San Ponso",
        "San Raffaele Cimena",
        "San Sebastiano da Po",
        "San Secondo di Pinerolo",
        "Sant\u0027Ambrogio di Torino",
        "Sant\u0027Antonino di Susa",
        "Santena",
        "Sauze di Cesana",
        "Sauze d\u0027Oulx",
        "Scalenghe",
        "Scarmagno",
        "Sciolze",
        "Sestriere",
        "Settimo Rottaro",
        "Settimo Torinese",
        "Settimo Vittone",
        "Sparone",
        "Strambinello",
        "Strambino",
        "Susa",
        "Tavagnasco",
        "Torino",
        "Torrazza Piemonte",
        "Torre Canavese",
        "Torre Pellice",
        "Trana",
        "Traversella",
        "Traves",
        "Trofarello",
        "Usseaux",
        "Usseglio",
        "Vaie",
        "Val della Torre",
        "Valgioie",
        "Vallo Torinese",
        "Valperga",
        "Valprato Soana",
        "Varisella",
        "Vauda Canavese",
        "Venaus",
        "Venaria Reale",
        "Verolengo",
        "Verrua Savoia",
        "Vestignè",
        "Vialfrè",
        "Vidracco",
        "Vigone",
        "Villafranca Piemonte",
        "Villanova Canavese",
        "Villarbasse",
        "Villar Dora",
        "Villareggia",
        "Villar Focchiardo",
        "Villar Pellice",
        "Villar Perosa",
        "Villastellone",
        "Vinovo",
        "Virle Piemonte",
        "Vische",
        "Vistrorio",
        "Viù",
        "Volpiano",
        "Volvera",
        "Mappano",
        "Val di Chy",
        "Valchiusa"
    ]],
    ["TP", [
        "Alcamo",
        "Buseto Palizzolo",
        "Calatafimi-Segesta",
        "Campobello di Mazara",
        "Castellammare del Golfo",
        "Castelvetrano",
        "Custonaci",
        "Erice",
        "Favignana",
        "Gibellina",
        "Marsala",
        "Mazara del Vallo",
        "Paceco",
        "Pantelleria",
        "Partanna",
        "Poggioreale",
        "Salaparuta",
        "Salemi",
        "Santa Ninfa",
        "San Vito Lo Capo",
        "Trapani",
        "Valderice",
        "Vita",
        "Petrosino",
        "Misiliscemi"
    ]],
    ["LI", [
        "Bibbona",
        "Campiglia Marittima",
        "Campo nell\u0027Elba",
        "Capoliveri",
        "Capraia Isola",
        "Castagneto Carducci",
        "Cecina",
        "Collesalvetti",
        "Livorno",
        "Marciana",
        "Marciana Marina",
        "Piombino",
        "Porto Azzurro",
        "Portoferraio",
        "Rosignano Marittimo",
        "San Vincenzo",
        "Sassetta",
        "Suvereto",
        "Rio"
    ]],
    ["TR", [
        "Acquasparta",
        "Allerona",
        "Alviano",
        "Amelia",
        "Arrone",
        "Attigliano",
        "Baschi",
        "Calvi dell\u0027Umbria",
        "Castel Giorgio",
        "Castel Viscardo",
        "Fabro",
        "Ferentillo",
        "Ficulle",
        "Giove",
        "Guardea",
        "Lugnano in Teverina",
        "Montecastrilli",
        "Montecchio",
        "Montefranco",
        "Montegabbione",
        "Monteleone d\u0027Orvieto",
        "Narni",
        "Orvieto",
        "Otricoli",
        "Parrano",
        "Penna in Teverina",
        "Polino",
        "Porano",
        "San Gemini",
        "San Venanzo",
        "Stroncone",
        "Terni",
        "Avigliano Umbro"
    ]],
    ["TS", [
        "Duino Aurisina",
        "Monrupino",
        "Muggia",
        "San Dorligo della Valle",
        "Sgonico",
        "Trieste"
    ]],
    ["TV", [
        "Altivole",
        "Arcade",
        "Asolo",
        "Borso del Grappa",
        "Breda di Piave",
        "Caerano di San Marco",
        "Cappella Maggiore",
        "Carbonera",
        "Casale sul Sile",
        "Casier",
        "Castelcucco",
        "Castelfranco Veneto",
        "Castello di Godego",
        "Cavaso del Tomba",
        "Cessalto",
        "Chiarano",
        "Cimadolmo",
        "Cison di Valmarino",
        "Codognè",
        "Colle Umberto",
        "Conegliano",
        "Cordignano",
        "Cornuda",
        "Crocetta del Montello",
        "Farra di Soligo",
        "Follina",
        "Fontanelle",
        "Fonte",
        "Fregona",
        "Gaiarine",
        "Giavera del Montello",
        "Godega di Sant\u0027Urbano",
        "Gorgo al Monticano",
        "Istrana",
        "Loria",
        "Mansuè",
        "Mareno di Piave",
        "Maser",
        "Maserada sul Piave",
        "Meduna di Livenza",
        "Miane",
        "Mogliano Veneto",
        "Monastier di Treviso",
        "Monfumo",
        "Montebelluna",
        "Morgano",
        "Moriago della Battaglia",
        "Motta di Livenza",
        "Nervesa della Battaglia",
        "Oderzo",
        "Ormelle",
        "Orsago",
        "Paese",
        "Pederobba",
        "Pieve di Soligo",
        "Ponte di Piave",
        "Ponzano Veneto",
        "Portobuffolè",
        "Possagno",
        "Povegliano",
        "Preganziol",
        "Quinto di Treviso",
        "Refrontolo",
        "Resana",
        "Revine Lago",
        "Riese Pio X",
        "Roncade",
        "Salgareda",
        "San Biagio di Callalta",
        "San Fior",
        "San Pietro di Feletto",
        "San Polo di Piave",
        "Santa Lucia di Piave",
        "San Vendemiano",
        "San Zenone degli Ezzelini",
        "Sarmede",
        "Segusino",
        "Sernaglia della Battaglia",
        "Silea",
        "Spresiano",
        "Susegana",
        "Tarzo",
        "Trevignano",
        "Treviso",
        "Valdobbiadene",
        "Vazzola",
        "Vedelago",
        "Vidor",
        "Villorba",
        "Vittorio Veneto",
        "Volpago del Montello",
        "Zenson di Piave",
        "Zero Branco",
        "Pieve del Grappa"
    ]],
    ["LO", [
        "Abbadia Cerreto",
        "Bertonico",
        "Boffalora d\u0027Adda",
        "Borghetto Lodigiano",
        "Borgo San Giovanni",
        "Brembio",
        "Casaletto Lodigiano",
        "Casalmaiocco",
        "Casalpusterlengo",
        "Caselle Landi",
        "Caselle Lurani",
        "Castelnuovo Bocca d\u0027Adda",
        "Castiglione d\u0027Adda",
        "Castiraga Vidardo",
        "Cavenago d\u0027Adda",
        "Cervignano d\u0027Adda",
        "Codogno",
        "Comazzo",
        "Cornegliano Laudense",
        "Corno Giovine",
        "Cornovecchio",
        "Corte Palasio",
        "Crespiatica",
        "Fombio",
        "Galgagnano",
        "Graffignana",
        "Guardamiglio",
        "Livraga",
        "Lodi",
        "Lodi Vecchio",
        "Maccastorna",
        "Mairago",
        "Maleo",
        "Marudo",
        "Massalengo",
        "Meleti",
        "Merlino",
        "Montanaso Lombardo",
        "Mulazzano",
        "Orio Litta",
        "Ospedaletto Lodigiano",
        "Ossago Lodigiano",
        "Pieve Fissiraga",
        "Salerano sul Lambro",
        "San Fiorano",
        "San Martino in Strada",
        "San Rocco al Porto",
        "Sant\u0027Angelo Lodigiano",
        "Santo Stefano Lodigiano",
        "Secugnago",
        "Senna Lodigiana",
        "Somaglia",
        "Sordio",
        "Tavazzano con Villavesco",
        "Terranova dei Passerini",
        "Turano Lodigiano",
        "Valera Fratta",
        "Villanova del Sillaro",
        "Zelo Buon Persico",
        "Castelgerundo"
    ]],
    ["LT", [
        "Aprilia",
        "Bassiano",
        "Campodimele",
        "Castelforte",
        "Cisterna di Latina",
        "Cori",
        "Fondi",
        "Formia",
        "Gaeta",
        "Itri",
        "Latina",
        "Lenola",
        "Maenza",
        "Minturno",
        "Monte San Biagio",
        "Norma",
        "Pontinia",
        "Ponza",
        "Priverno",
        "Prossedi",
        "Roccagorga",
        "Rocca Massima",
        "Roccasecca dei Volsci",
        "Sabaudia",
        "San Felice Circeo",
        "Santi Cosma e Damiano",
        "Sermoneta",
        "Sezze",
        "Sonnino",
        "Sperlonga",
        "Spigno Saturnia",
        "Terracina",
        "Ventotene"
    ]],
    ["LU", [
        "Altopascio",
        "Bagni di Lucca",
        "Barga",
        "Borgo a Mozzano",
        "Camaiore",
        "Camporgiano",
        "Capannori",
        "Careggine",
        "Castelnuovo di Garfagnana",
        "Castiglione di Garfagnana",
        "Coreglia Antelminelli",
        "Forte dei Marmi",
        "Fosciandora",
        "Gallicano",
        "Lucca",
        "Massarosa",
        "Minucciano",
        "Molazzana",
        "Montecarlo",
        "Pescaglia",
        "Piazza al Serchio",
        "Pietrasanta",
        "Pieve Fosciana",
        "Porcari",
        "San Romano in Garfagnana",
        "Seravezza",
        "Stazzema",
        "Vagli Sotto",
        "Viareggio",
        "Villa Basilica",
        "Villa Collemandina",
        "Fabbriche di Vergemoli",
        "Sillano Giuncugnano"
    ]],
    ["UD", [
        "Aiello del Friuli",
        "Amaro",
        "Ampezzo",
        "Aquileia",
        "Arta Terme",
        "Artegna",
        "Attimis",
        "Bagnaria Arsa",
        "Basiliano",
        "Bertiolo",
        "Bicinicco",
        "Bordano",
        "Buja",
        "Buttrio",
        "Camino al Tagliamento",
        "Campoformido",
        "Carlino",
        "Cassacco",
        "Castions di Strada",
        "Cavazzo Carnico",
        "Cercivento",
        "Cervignano del Friuli",
        "Chiopris-Viscone",
        "Chiusaforte",
        "Cividale del Friuli",
        "Codroipo",
        "Colloredo di Monte Albano",
        "Comeglians",
        "Corno di Rosazzo",
        "Coseano",
        "Dignano",
        "Dogna",
        "Drenchia",
        "Enemonzo",
        "Faedis",
        "Fagagna",
        "Flaibano",
        "Forni Avoltri",
        "Forni di Sopra",
        "Forni di Sotto",
        "Gemona del Friuli",
        "Gonars",
        "Grimacco",
        "Latisana",
        "Lauco",
        "Lestizza",
        "Lignano Sabbiadoro",
        "Lusevera",
        "Magnano in Riviera",
        "Majano",
        "Malborghetto Valbruna",
        "Manzano",
        "Marano Lagunare",
        "Martignacco",
        "Mereto di Tomba",
        "Moggio Udinese",
        "Moimacco",
        "Montenars",
        "Mortegliano",
        "Moruzzo",
        "Muzzana del Turgnano",
        "Nimis",
        "Osoppo",
        "Ovaro",
        "Pagnacco",
        "Palazzolo dello Stella",
        "Palmanova",
        "Paluzza",
        "Pasian di Prato",
        "Paularo",
        "Pavia di Udine",
        "Pocenia",
        "Pontebba",
        "Porpetto",
        "Povoletto",
        "Pozzuolo del Friuli",
        "Pradamano",
        "Prato Carnico",
        "Precenicco",
        "Premariacco",
        "Preone",
        "Prepotto",
        "Pulfero",
        "Ragogna",
        "Ravascletto",
        "Raveo",
        "Reana del Rojale",
        "Remanzacco",
        "Resia",
        "Resiutta",
        "Rigolato",
        "Rive d\u0027Arcano",
        "Ronchis",
        "Ruda",
        "San Daniele del Friuli",
        "San Giorgio di Nogaro",
        "San Giovanni al Natisone",
        "San Leonardo",
        "San Pietro al Natisone",
        "Santa Maria la Longa",
        "San Vito al Torre",
        "San Vito di Fagagna",
        "Sauris",
        "Savogna",
        "Sedegliano",
        "Socchieve",
        "Stregna",
        "Sutrio",
        "Taipana",
        "Talmassons",
        "Tarcento",
        "Tarvisio",
        "Tavagnacco",
        "Terzo d\u0027Aquileia",
        "Tolmezzo",
        "Torreano",
        "Torviscosa",
        "Trasaghis",
        "Treppo Grande",
        "Tricesimo",
        "Trivignano Udinese",
        "Udine",
        "Varmo",
        "Venzone",
        "Verzegnis",
        "Villa Santina",
        "Visco",
        "Zuglio",
        "Forgaria nel Friuli",
        "Campolongo Tapogliano",
        "Rivignano Teor",
        "Sappada",
        "Fiumicello Villa Vicentina",
        "Treppo Ligosullo"
    ]],
    ["MB", [
        "Agrate Brianza",
        "Aicurzio",
        "Albiate",
        "Arcore",
        "Barlassina",
        "Bellusco",
        "Bernareggio",
        "Besana in Brianza",
        "Biassono",
        "Bovisio-Masciago",
        "Briosco",
        "Brugherio",
        "Burago di Molgora",
        "Camparada",
        "Carate Brianza",
        "Carnate",
        "Cavenago di Brianza",
        "Ceriano Laghetto",
        "Cesano Maderno",
        "Cogliate",
        "Concorezzo",
        "Correzzana",
        "Desio",
        "Giussano",
        "Lazzate",
        "Lesmo",
        "Limbiate",
        "Lissone",
        "Macherio",
        "Meda",
        "Mezzago",
        "Misinto",
        "Monza",
        "Muggiò",
        "Nova Milanese",
        "Ornago",
        "Renate",
        "Ronco Briantino",
        "Seregno",
        "Seveso",
        "Sovico",
        "Sulbiate",
        "Triuggio",
        "Usmate Velate",
        "Varedo",
        "Vedano al Lambro",
        "Veduggio con Colzano",
        "Verano Brianza",
        "Villasanta",
        "Vimercate",
        "Busnago",
        "Caponago",
        "Cornate d\u0027Adda",
        "Lentate sul Seveso",
        "Roncello"
    ]],
    ["MC", [
        "Apiro",
        "Appignano",
        "Belforte del Chienti",
        "Bolognola",
        "Caldarola",
        "Camerino",
        "Camporotondo di Fiastrone",
        "Castelraimondo",
        "Castelsantangelo sul Nera",
        "Cessapalombo",
        "Cingoli",
        "Civitanova Marche",
        "Colmurano",
        "Corridonia",
        "Esanatoglia",
        "Fiastra",
        "Fiuminata",
        "Gagliole",
        "Gualdo",
        "Loro Piceno",
        "Macerata",
        "Matelica",
        "Mogliano",
        "Montecassiano",
        "Monte Cavallo",
        "Montecosaro",
        "Montefano",
        "Montelupone",
        "Monte San Giusto",
        "Monte San Martino",
        "Morrovalle",
        "Muccia",
        "Penna San Giovanni",
        "Petriolo",
        "Pieve Torina",
        "Pioraco",
        "Poggio San Vicino",
        "Pollenza",
        "Porto Recanati",
        "Potenza Picena",
        "Recanati",
        "Ripe San Ginesio",
        "San Ginesio",
        "San Severino Marche",
        "Sant\u0027Angelo in Pontano",
        "Sarnano",
        "Sefro",
        "Serrapetrona",
        "Serravalle di Chienti",
        "Tolentino",
        "Treia",
        "Urbisaglia",
        "Ussita",
        "Visso",
        "Valfornace"
    ]],
    ["ME", [
        "Alcara li Fusi",
        "Alì",
        "Alì Terme",
        "Antillo",
        "Barcellona Pozzo di Gotto",
        "Basicò",
        "Brolo",
        "Capizzi",
        "Capo d\u0027Orlando",
        "Capri Leone",
        "Caronia",
        "Casalvecchio Siculo",
        "Castel di Lucio",
        "Castell\u0027Umberto",
        "Castelmola",
        "Castroreale",
        "Cesarò",
        "Condrò",
        "Falcone",
        "Ficarra",
        "Fiumedinisi",
        "Floresta",
        "Fondachelli-Fantina",
        "Forza d\u0027Agrò",
        "Francavilla di Sicilia",
        "Frazzanò",
        "Furci Siculo",
        "Furnari",
        "Gaggi",
        "Galati Mamertino",
        "Gallodoro",
        "Giardini-Naxos",
        "Gioiosa Marea",
        "Graniti",
        "Gualtieri Sicaminò",
        "Itala",
        "Leni",
        "Letojanni",
        "Librizzi",
        "Limina",
        "Lipari",
        "Longi",
        "Malfa",
        "Malvagna",
        "Mandanici",
        "Mazzarrà Sant\u0027Andrea",
        "Merì",
        "Messina",
        "Milazzo",
        "Militello Rosmarino",
        "Mirto",
        "Mistretta",
        "Moio Alcantara",
        "Monforte San Giorgio",
        "Mongiuffi Melia",
        "Montagnareale",
        "Montalbano Elicona",
        "Motta Camastra",
        "Motta d\u0027Affermo",
        "Naso",
        "Nizza di Sicilia",
        "Novara di Sicilia",
        "Oliveri",
        "Pace del Mela",
        "Pagliara",
        "Patti",
        "Pettineo",
        "Piraino",
        "Raccuja",
        "Reitano",
        "Roccafiorita",
        "Roccalumera",
        "Roccavaldina",
        "Roccella Valdemone",
        "Rodì Milici",
        "Rometta",
        "San Filippo del Mela",
        "San Fratello",
        "San Marco d\u0027Alunzio",
        "San Pier Niceto",
        "San Piero Patti",
        "San Salvatore di Fitalia",
        "Santa Domenica Vittoria",
        "Sant\u0027Agata di Militello",
        "Sant\u0027Alessio Siculo",
        "Santa Lucia del Mela",
        "Santa Marina Salina",
        "Sant\u0027Angelo di Brolo",
        "Santa Teresa di Riva",
        "San Teodoro",
        "Santo Stefano di Camastra",
        "Saponara",
        "Savoca",
        "Scaletta Zanclea",
        "Sinagra",
        "Spadafora",
        "Taormina",
        "Torregrotta",
        "Tortorici",
        "Tripi",
        "Tusa",
        "Ucria",
        "Valdina",
        "Venetico",
        "Villafranca Tirrena",
        "Terme Vigliatore",
        "Acquedolci",
        "Torrenova"
    ]],
    ["MI", [
        "Abbiategrasso",
        "Albairate",
        "Arconate",
        "Arese",
        "Arluno",
        "Assago",
        "Bareggio",
        "Basiano",
        "Basiglio",
        "Bellinzago Lombardo",
        "Bernate Ticino",
        "Besate",
        "Binasco",
        "Boffalora sopra Ticino",
        "Bollate",
        "Bresso",
        "Bubbiano",
        "Buccinasco",
        "Buscate",
        "Bussero",
        "Busto Garolfo",
        "Calvignasco",
        "Cambiago",
        "Canegrate",
        "Carpiano",
        "Carugate",
        "Casarile",
        "Casorezzo",
        "Cassano d\u0027Adda",
        "Cassina de\u0027 Pecchi",
        "Cassinetta di Lugagnano",
        "Castano Primo",
        "Cernusco sul Naviglio",
        "Cerro al Lambro",
        "Cerro Maggiore",
        "Cesano Boscone",
        "Cesate",
        "Cinisello Balsamo",
        "Cisliano",
        "Cologno Monzese",
        "Colturano",
        "Corbetta",
        "Cormano",
        "Cornaredo",
        "Corsico",
        "Cuggiono",
        "Cusago",
        "Cusano Milanino",
        "Dairago",
        "Dresano",
        "Gaggiano",
        "Garbagnate Milanese",
        "Gessate",
        "Gorgonzola",
        "Grezzago",
        "Gudo Visconti",
        "Inveruno",
        "Inzago",
        "Lacchiarella",
        "Lainate",
        "Legnano",
        "Liscate",
        "Locate di Triulzi",
        "Magenta",
        "Magnago",
        "Marcallo con Casone",
        "Masate",
        "Mediglia",
        "Melegnano",
        "Melzo",
        "Mesero",
        "Milano",
        "Morimondo",
        "Motta Visconti",
        "Nerviano",
        "Nosate",
        "Novate Milanese",
        "Noviglio",
        "Opera",
        "Ossona",
        "Ozzero",
        "Paderno Dugnano",
        "Pantigliate",
        "Parabiago",
        "Paullo",
        "Pero",
        "Peschiera Borromeo",
        "Pessano con Bornago",
        "Pieve Emanuele",
        "Pioltello",
        "Pogliano Milanese",
        "Pozzo d\u0027Adda",
        "Pozzuolo Martesana",
        "Pregnana Milanese",
        "Rescaldina",
        "Rho",
        "Robecchetto con Induno",
        "Robecco sul Naviglio",
        "Rodano",
        "Rosate",
        "Rozzano",
        "San Colombano al Lambro",
        "San Donato Milanese",
        "San Giorgio su Legnano",
        "San Giuliano Milanese",
        "Santo Stefano Ticino",
        "San Vittore Olona",
        "San Zenone al Lambro",
        "Sedriano",
        "Segrate",
        "Senago",
        "Sesto San Giovanni",
        "Settala",
        "Settimo Milanese",
        "Solaro",
        "Trezzano Rosa",
        "Trezzano sul Naviglio",
        "Trezzo sull\u0027Adda",
        "Tribiano",
        "Truccazzano",
        "Turbigo",
        "Vanzago",
        "Vaprio d\u0027Adda",
        "Vernate",
        "Vignate",
        "Vimodrone",
        "Vittuone",
        "Vizzolo Predabissi",
        "Zibido San Giacomo",
        "Villa Cortese",
        "Vanzaghello",
        "Baranzate",
        "Vermezzo con Zelo"
    ]],
    ["MN", [
        "Acquanegra sul Chiese",
        "Asola",
        "Bagnolo San Vito",
        "Bozzolo",
        "Canneto sull\u0027Oglio",
        "Casalmoro",
        "Casaloldo",
        "Casalromano",
        "Castelbelforte",
        "Castel d\u0027Ario",
        "Castel Goffredo",
        "Castellucchio",
        "Castiglione delle Stiviere",
        "Cavriana",
        "Ceresara",
        "Commessaggio",
        "Curtatone",
        "Dosolo",
        "Gazoldo degli Ippoliti",
        "Gazzuolo",
        "Goito",
        "Gonzaga",
        "Guidizzolo",
        "Magnacavallo",
        "Mantova",
        "Marcaria",
        "Mariana Mantovana",
        "Marmirolo",
        "Medole",
        "Moglia",
        "Monzambano",
        "Motteggiana",
        "Ostiglia",
        "Pegognaga",
        "Piubega",
        "Poggio Rusco",
        "Pomponesco",
        "Ponti sul Mincio",
        "Porto Mantovano",
        "Quingentole",
        "Quistello",
        "Redondesco",
        "Rivarolo Mantovano",
        "Rodigo",
        "Roncoferraro",
        "Roverbella",
        "Sabbioneta",
        "San Benedetto Po",
        "San Giacomo delle Segnate",
        "San Giorgio Bigarello",
        "San Giovanni del Dosso",
        "San Martino dall\u0027Argine",
        "Schivenoglia",
        "Sermide e Felonica",
        "Serravalle a Po",
        "Solferino",
        "Sustinente",
        "Suzzara",
        "Viadana",
        "Villimpenta",
        "Volta Mantovana",
        "Borgo Virgilio",
        "Borgo Mantovano",
        "Borgocarbonara"
    ]],
    ["MO", [
        "Bastiglia",
        "Bomporto",
        "Campogalliano",
        "Camposanto",
        "Carpi",
        "Castelfranco Emilia",
        "Castelnuovo Rangone",
        "Castelvetro di Modena",
        "Cavezzo",
        "Concordia sulla Secchia",
        "Fanano",
        "Finale Emilia",
        "Fiorano Modenese",
        "Fiumalbo",
        "Formigine",
        "Frassinoro",
        "Guiglia",
        "Lama Mocogno",
        "Maranello",
        "Marano sul Panaro",
        "Medolla",
        "Mirandola",
        "Modena",
        "Montecreto",
        "Montefiorino",
        "Montese",
        "Nonantola",
        "Novi di Modena",
        "Palagano",
        "Pavullo nel Frignano",
        "Pievepelago",
        "Polinago",
        "Prignano sulla Secchia",
        "Ravarino",
        "Riolunato",
        "San Cesario sul Panaro",
        "San Felice sul Panaro",
        "San Possidonio",
        "San Prospero",
        "Sassuolo",
        "Savignano sul Panaro",
        "Serramazzoni",
        "Sestola",
        "Soliera",
        "Spilamberto",
        "Vignola",
        "Zocca"
    ]],
    ["MS", [
        "Aulla",
        "Bagnone",
        "Carrara",
        "Casola in Lunigiana",
        "Comano",
        "Filattiera",
        "Fivizzano",
        "Fosdinovo",
        "Licciana Nardi",
        "Massa",
        "Montignoso",
        "Mulazzo",
        "Podenzana",
        "Pontremoli",
        "Tresana",
        "Villafranca in Lunigiana",
        "Zeri"
    ]],
    ["MT", [
        "Accettura",
        "Aliano",
        "Bernalda",
        "Calciano",
        "Cirigliano",
        "Colobraro",
        "Craco",
        "Ferrandina",
        "Garaguso",
        "Gorgoglione",
        "Grassano",
        "Grottole",
        "Irsina",
        "Matera",
        "Miglionico",
        "Montalbano Jonico",
        "Montescaglioso",
        "Nova Siri",
        "Oliveto Lucano",
        "Pisticci",
        "Policoro",
        "Pomarico",
        "Rotondella",
        "Salandra",
        "San Giorgio Lucano",
        "San Mauro Forte",
        "Stigliano",
        "Tricarico",
        "Tursi",
        "Valsinni",
        "Scanzano Jonico"
    ]],
    ["EN", [
        "Agira",
        "Aidone",
        "Assoro",
        "Barrafranca",
        "Calascibetta",
        "Catenanuova",
        "Centuripe",
        "Cerami",
        "Enna",
        "Gagliano Castelferrato",
        "Leonforte",
        "Nicosia",
        "Nissoria",
        "Piazza Armerina",
        "Pietraperzia",
        "Regalbuto",
        "Sperlinga",
        "Troina",
        "Valguarnera Caropepe",
        "Villarosa"
    ]],
    ["VA", [
        "Agra",
        "Albizzate",
        "Angera",
        "Arcisate",
        "Arsago Seprio",
        "Azzate",
        "Azzio",
        "Barasso",
        "Bedero Valcuvia",
        "Besano",
        "Besnate",
        "Besozzo",
        "Biandronno",
        "Bisuschio",
        "Bodio Lomnago",
        "Brebbia",
        "Brenta",
        "Brezzo di Bedero",
        "Brinzio",
        "Brissago-Valtravaglia",
        "Brunello",
        "Brusimpiano",
        "Buguggiate",
        "Busto Arsizio",
        "Cadegliano-Viconago",
        "Cairate",
        "Cantello",
        "Caravate",
        "Cardano al Campo",
        "Carnago",
        "Caronno Pertusella",
        "Caronno Varesino",
        "Casale Litta",
        "Casalzuigno",
        "Casciago",
        "Casorate Sempione",
        "Cassano Magnago",
        "Cassano Valcuvia",
        "Castellanza",
        "Castello Cabiaglio",
        "Castelseprio",
        "Castelveccana",
        "Castiglione Olona",
        "Castronno",
        "Cavaria con Premezzo",
        "Cazzago Brabbia",
        "Cislago",
        "Cittiglio",
        "Clivio",
        "Cocquio-Trevisago",
        "Comabbio",
        "Comerio",
        "Cremenaga",
        "Crosio della Valle",
        "Cuasso al Monte",
        "Cugliate-Fabiasco",
        "Cunardo",
        "Curiglia con Monteviasco",
        "Cuveglio",
        "Cuvio",
        "Daverio",
        "Dumenza",
        "Duno",
        "Fagnano Olona",
        "Ferno",
        "Ferrera di Varese",
        "Gallarate",
        "Galliate Lombardo",
        "Gavirate",
        "Gazzada Schianno",
        "Gemonio",
        "Gerenzano",
        "Germignaga",
        "Golasecca",
        "Gorla Maggiore",
        "Gorla Minore",
        "Gornate Olona",
        "Grantola",
        "Inarzo",
        "Induno Olona",
        "Ispra",
        "Jerago con Orago",
        "Lavena Ponte Tresa",
        "Laveno-Mombello",
        "Leggiuno",
        "Lonate Ceppino",
        "Lonate Pozzolo",
        "Lozza",
        "Luino",
        "Luvinate",
        "Malnate",
        "Marchirolo",
        "Marnate",
        "Marzio",
        "Masciago Primo",
        "Mercallo",
        "Mesenzana",
        "Montegrino Valtravaglia",
        "Monvalle",
        "Morazzone",
        "Mornago",
        "Oggiona con Santo Stefano",
        "Olgiate Olona",
        "Origgio",
        "Orino",
        "Porto Ceresio",
        "Porto Valtravaglia",
        "Rancio Valcuvia",
        "Ranco",
        "Saltrio",
        "Samarate",
        "Saronno",
        "Sesto Calende",
        "Solbiate Arno",
        "Solbiate Olona",
        "Somma Lombardo",
        "Sumirago",
        "Taino",
        "Ternate",
        "Tradate",
        "Travedona-Monate",
        "Tronzano Lago Maggiore",
        "Uboldo",
        "Valganna",
        "Varano Borghi",
        "Varese",
        "Vedano Olona",
        "Venegono Inferiore",
        "Venegono Superiore",
        "Vergiate",
        "Viggiù",
        "Vizzola Ticino",
        "Sangiano",
        "Maccagno con Pino e Veddasca",
        "Cadrezzate con Osmate",
        "Bardello con Malgesso e Bregano"
    ]],
    ["VB", [
        "Antrona Schieranco",
        "Anzola d\u0027Ossola",
        "Arizzano",
        "Arola",
        "Aurano",
        "Baceno",
        "Bannio Anzino",
        "Baveno",
        "Bee",
        "Belgirate",
        "Beura-Cardezza",
        "Bognanco",
        "Brovello-Carpugnino",
        "Calasca-Castiglione",
        "Cambiasca",
        "Cannero Riviera",
        "Cannobio",
        "Caprezzo",
        "Casale Corte Cerro",
        "Ceppo Morelli",
        "Cesara",
        "Cossogno",
        "Craveggia",
        "Crevoladossola",
        "Crodo",
        "Domodossola",
        "Druogno",
        "Formazza",
        "Germagno",
        "Ghiffa",
        "Gignese",
        "Gravellona Toce",
        "Gurro",
        "Intragna",
        "Loreglia",
        "Macugnaga",
        "Madonna del Sasso",
        "Malesco",
        "Masera",
        "Massiola",
        "Mergozzo",
        "Miazzina",
        "Montecrestese",
        "Montescheno",
        "Nonio",
        "Oggebbio",
        "Omegna",
        "Ornavasso",
        "Pallanzeno",
        "Piedimulera",
        "Pieve Vergonte",
        "Premeno",
        "Premia",
        "Premosello-Chiovenda",
        "Quarna Sopra",
        "Quarna Sotto",
        "Re",
        "San Bernardino Verbano",
        "Santa Maria Maggiore",
        "Stresa",
        "Toceno",
        "Trarego Viggiona",
        "Trasquera",
        "Trontano",
        "Valstrona",
        "Vanzone con San Carlo",
        "Varzo",
        "Verbania",
        "Vignone",
        "Villadossola",
        "Villette",
        "Vogogna",
        "Borgomezzavalle",
        "Valle Cannobina"
    ]],
    ["VC", [
        "Alagna Valsesia",
        "Albano Vercellese",
        "Alice Castello",
        "Arborio",
        "Asigliano Vercellese",
        "Balmuccia",
        "Balocco",
        "Bianzè",
        "Boccioleto",
        "Borgo d\u0027Ale",
        "Borgosesia",
        "Borgo Vercelli",
        "Buronzo",
        "Campertogno",
        "Carcoforo",
        "Caresana",
        "Caresanablot",
        "Carisio",
        "Casanova Elvo",
        "San Giacomo Vercellese",
        "Cervatto",
        "Cigliano",
        "Civiasco",
        "Collobiano",
        "Costanzana",
        "Cravagliana",
        "Crescentino",
        "Crova",
        "Desana",
        "Fobello",
        "Fontanetto Po",
        "Formigliana",
        "Gattinara",
        "Ghislarengo",
        "Greggio",
        "Guardabosone",
        "Lamporo",
        "Lenta",
        "Lignana",
        "Livorno Ferraris",
        "Lozzolo",
        "Mollia",
        "Moncrivello",
        "Motta de\u0027 Conti",
        "Olcenengo",
        "Oldenico",
        "Palazzolo Vercellese",
        "Pertengo",
        "Pezzana",
        "Pila",
        "Piode",
        "Postua",
        "Prarolo",
        "Quarona",
        "Quinto Vercellese",
        "Rassa",
        "Rimella",
        "Rive",
        "Roasio",
        "Ronsecco",
        "Rossa",
        "Rovasenda",
        "Salasco",
        "Sali Vercellese",
        "Saluggia",
        "San Germano Vercellese",
        "Santhià",
        "Scopa",
        "Scopello",
        "Serravalle Sesia",
        "Stroppiana",
        "Tricerro",
        "Trino",
        "Tronzano Vercellese",
        "Valduggia",
        "Varallo",
        "Vercelli",
        "Villarboit",
        "Villata",
        "Vocca",
        "Alto Sermenza",
        "Cellio con Breia"
    ]],
    ["VE", [
        "Annone Veneto",
        "Campagna Lupia",
        "Campolongo Maggiore",
        "Camponogara",
        "Caorle",
        "Cavarzere",
        "Ceggia",
        "Chioggia",
        "Cinto Caomaggiore",
        "Cona",
        "Concordia Sagittaria",
        "Dolo",
        "Eraclea",
        "Fiesso d\u0027Artico",
        "Fossalta di Piave",
        "Fossalta di Portogruaro",
        "Fossò",
        "Gruaro",
        "Jesolo",
        "Marcon",
        "Martellago",
        "Meolo",
        "Mira",
        "Mirano",
        "Musile di Piave",
        "Noale",
        "Noventa di Piave",
        "Pianiga",
        "Portogruaro",
        "Pramaggiore",
        "Quarto d\u0027Altino",
        "Salzano",
        "San Donà di Piave",
        "San Michele al Tagliamento",
        "Santa Maria di Sala",
        "San Stino di Livenza",
        "Scorzè",
        "Spinea",
        "Stra",
        "Teglio Veneto",
        "Torre di Mosto",
        "Venezia",
        "Vigonovo",
        "Cavallino-Treporti"
    ]],
    ["NA", [
        "Acerra",
        "Afragola",
        "Agerola",
        "Anacapri",
        "Arzano",
        "Bacoli",
        "Barano d\u0027Ischia",
        "Boscoreale",
        "Boscotrecase",
        "Brusciano",
        "Caivano",
        "Calvizzano",
        "Camposano",
        "Capri",
        "Carbonara di Nola",
        "Cardito",
        "Casalnuovo di Napoli",
        "Casamarciano",
        "Casamicciola Terme",
        "Casandrino",
        "Casavatore",
        "Casola di Napoli",
        "Casoria",
        "Castellammare di Stabia",
        "Castello di Cisterna",
        "Cercola",
        "Cicciano",
        "Cimitile",
        "Comiziano",
        "Crispano",
        "Forio",
        "Frattamaggiore",
        "Frattaminore",
        "Giugliano in Campania",
        "Gragnano",
        "Grumo Nevano",
        "Ischia",
        "Lacco Ameno",
        "Lettere",
        "Liveri",
        "Marano di Napoli",
        "Mariglianella",
        "Marigliano",
        "Massa Lubrense",
        "Melito di Napoli",
        "Meta",
        "Monte di Procida",
        "Mugnano di Napoli",
        "Napoli",
        "Nola",
        "Ottaviano",
        "Palma Campania",
        "Piano di Sorrento",
        "Pimonte",
        "Poggiomarino",
        "Pollena Trocchia",
        "Pomigliano d\u0027Arco",
        "Pompei",
        "Portici",
        "Pozzuoli",
        "Procida",
        "Qualiano",
        "Quarto",
        "Ercolano",
        "Roccarainola",
        "San Gennaro Vesuviano",
        "San Giorgio a Cremano",
        "San Giuseppe Vesuviano",
        "San Paolo Bel Sito",
        "San Sebastiano al Vesuvio",
        "Sant\u0027Agnello",
        "Sant\u0027Anastasia",
        "Sant\u0027Antimo",
        "Sant\u0027Antonio Abate",
        "San Vitaliano",
        "Saviano",
        "Scisciano",
        "Serrara Fontana",
        "Somma Vesuviana",
        "Sorrento",
        "Striano",
        "Terzigno",
        "Torre Annunziata",
        "Torre del Greco",
        "Tufino",
        "Vico Equense",
        "Villaricca",
        "Visciano",
        "Volla",
        "Santa Maria la Carità",
        "Trecase",
        "Massa di Somma"
    ]],
    ["VI", [
        "Agugliaro",
        "Albettone",
        "Alonte",
        "Altavilla Vicentina",
        "Altissimo",
        "Arcugnano",
        "Arsiero",
        "Arzignano",
        "Asiago",
        "Asigliano Veneto",
        "Bassano del Grappa",
        "Bolzano Vicentino",
        "Breganze",
        "Brendola",
        "Bressanvido",
        "Brogliano",
        "Caldogno",
        "Caltrano",
        "Calvene",
        "Camisano Vicentino",
        "Campiglia dei Berici",
        "Carrè",
        "Cartigliano",
        "Cassola",
        "Castegnero",
        "Castelgomberto",
        "Chiampo",
        "Chiuppano",
        "Cogollo del Cengio",
        "Cornedo Vicentino",
        "Costabissara",
        "Creazzo",
        "Crespadoro",
        "Dueville",
        "Enego",
        "Fara Vicentino",
        "Foza",
        "Gallio",
        "Gambellara",
        "Grisignano di Zocco",
        "Grumolo delle Abbadesse",
        "Isola Vicentina",
        "Laghi",
        "Lastebasse",
        "Longare",
        "Lonigo",
        "Lugo di Vicenza",
        "Malo",
        "Marano Vicentino",
        "Marostica",
        "Montebello Vicentino",
        "Montecchio Maggiore",
        "Montecchio Precalcino",
        "Monte di Malo",
        "Montegalda",
        "Montegaldella",
        "Monteviale",
        "Monticello Conte Otto",
        "Montorso Vicentino",
        "Mussolente",
        "Nanto",
        "Nogarole Vicentino",
        "Nove",
        "Noventa Vicentina",
        "Orgiano",
        "Pedemonte",
        "Pianezze",
        "Piovene Rocchette",
        "Pojana Maggiore",
        "Posina",
        "Pove del Grappa",
        "Pozzoleone",
        "Quinto Vicentino",
        "Recoaro Terme",
        "Roana",
        "Romano d\u0027Ezzelino",
        "Rosà",
        "Rossano Veneto",
        "Rotzo",
        "Salcedo",
        "Sandrigo",
        "San Pietro Mussolino",
        "Santorso",
        "San Vito di Leguzzano",
        "Sarcedo",
        "Sarego",
        "Schiavon",
        "Schio",
        "Solagna",
        "Sossano",
        "Tezze sul Brenta",
        "Thiene",
        "Tonezza del Cimone",
        "Torrebelvicino",
        "Torri di Quartesolo",
        "Trissino",
        "Valdagno",
        "Valdastico",
        "Valli del Pasubio",
        "Velo d\u0027Astico",
        "Vicenza",
        "Villaga",
        "Villaverla",
        "Zanè",
        "Zermeghedo",
        "Zovencedo",
        "Zugliano",
        "Val Liona",
        "Barbarano Mossano",
        "Valbrenta",
        "Colceresa",
        "Lusiana Conco",
        "Sovizzo"
    ]],
    ["VR", [
        "Affi",
        "Albaredo d\u0027Adige",
        "Angiari",
        "Arcole",
        "Badia Calavena",
        "Bardolino",
        "Belfiore",
        "Bevilacqua",
        "Bonavigo",
        "Boschi Sant\u0027Anna",
        "Bosco Chiesanuova",
        "Bovolone",
        "Brentino Belluno",
        "Brenzone sul Garda",
        "Bussolengo",
        "Buttapietra",
        "Caldiero",
        "Caprino Veronese",
        "Casaleone",
        "Castagnaro",
        "Castel d\u0027Azzano",
        "Castelnuovo del Garda",
        "Cavaion Veronese",
        "Cazzano di Tramigna",
        "Cerea",
        "Cerro Veronese",
        "Cologna Veneta",
        "Colognola ai Colli",
        "Concamarise",
        "Costermano sul Garda",
        "Dolcè",
        "Erbè",
        "Erbezzo",
        "Ferrara di Monte Baldo",
        "Fumane",
        "Garda",
        "Gazzo Veronese",
        "Grezzana",
        "Illasi",
        "Isola della Scala",
        "Isola Rizza",
        "Lavagno",
        "Lazise",
        "Legnago",
        "Malcesine",
        "Marano di Valpolicella",
        "Mezzane di Sotto",
        "Minerbe",
        "Montecchia di Crosara",
        "Monteforte d\u0027Alpone",
        "Mozzecane",
        "Negrar di Valpolicella",
        "Nogara",
        "Nogarole Rocca",
        "Oppeano",
        "Palù",
        "Pastrengo",
        "Pescantina",
        "Peschiera del Garda",
        "Povegliano Veronese",
        "Pressana",
        "Rivoli Veronese",
        "Roncà",
        "Ronco all\u0027Adige",
        "Roverchiara",
        "Roveredo di Guà",
        "Roverè Veronese",
        "Salizzole",
        "San Bonifacio",
        "San Giovanni Ilarione",
        "San Giovanni Lupatoto",
        "Sanguinetto",
        "San Martino Buon Albergo",
        "San Mauro di Saline",
        "San Pietro di Morubio",
        "San Pietro in Cariano",
        "Sant\u0027Ambrogio di Valpolicella",
        "Sant\u0027Anna d\u0027Alfaedo",
        "San Zeno di Montagna",
        "Selva di Progno",
        "Soave",
        "Sommacampagna",
        "Sona",
        "Sorgà",
        "Terrazzo",
        "Torri del Benaco",
        "Tregnago",
        "Trevenzuolo",
        "Valeggio sul Mincio",
        "Velo Veronese",
        "Verona",
        "Veronella",
        "Vestenanova",
        "Vigasio",
        "Villa Bartolomea",
        "Villafranca di Verona",
        "Zevio",
        "Zimella"
    ]],
    ["FC", [
        "Bagno di Romagna",
        "Bertinoro",
        "Borghi",
        "Castrocaro Terme e Terra del Sole",
        "Cesena",
        "Cesenatico",
        "Civitella di Romagna",
        "Dovadola",
        "Forlì",
        "Forlimpopoli",
        "Galeata",
        "Gambettola",
        "Gatteo",
        "Longiano",
        "Meldola",
        "Mercato Saraceno",
        "Modigliana",
        "Montiano",
        "Portico e San Benedetto",
        "Predappio",
        "Premilcuore",
        "Rocca San Casciano",
        "Roncofreddo",
        "San Mauro Pascoli",
        "Santa Sofia",
        "Sarsina",
        "Savignano sul Rubicone",
        "Sogliano al Rubicone",
        "Tredozio",
        "Verghereto"
    ]],
    ["VT", [
        "Acquapendente",
        "Arlena di Castro",
        "Bagnoregio",
        "Barbarano Romano",
        "Bassano Romano",
        "Bassano in Teverina",
        "Blera",
        "Bolsena",
        "Bomarzo",
        "Calcata",
        "Canepina",
        "Canino",
        "Capodimonte",
        "Capranica",
        "Caprarola",
        "Carbognano",
        "Castel Sant\u0027Elia",
        "Castiglione in Teverina",
        "Celleno",
        "Cellere",
        "Civita Castellana",
        "Civitella d\u0027Agliano",
        "Corchiano",
        "Fabrica di Roma",
        "Faleria",
        "Farnese",
        "Gallese",
        "Gradoli",
        "Graffignano",
        "Grotte di Castro",
        "Ischia di Castro",
        "Latera",
        "Lubriano",
        "Marta",
        "Montalto di Castro",
        "Montefiascone",
        "Monte Romano",
        "Monterosi",
        "Nepi",
        "Onano",
        "Oriolo Romano",
        "Orte",
        "Piansano",
        "Proceno",
        "Ronciglione",
        "Villa San Giovanni in Tuscia",
        "San Lorenzo Nuovo",
        "Soriano nel Cimino",
        "Sutri",
        "Tarquinia",
        "Tessennano",
        "Tuscania",
        "Valentano",
        "Vallerano",
        "Vasanello",
        "Vejano",
        "Vetralla",
        "Vignanello",
        "Viterbo",
        "Vitorchiano"
    ]],
    ["FE", [
        "Argenta",
        "Bondeno",
        "Cento",
        "Codigoro",
        "Comacchio",
        "Copparo",
        "Ferrara",
        "Jolanda di Savoia",
        "Lagosanto",
        "Masi Torello",
        "Mesola",
        "Ostellato",
        "Poggio Renatico",
        "Portomaggiore",
        "Vigarano Mainarda",
        "Voghiera",
        "Goro",
        "Fiscaglia",
        "Terre del Reno",
        "Riva del Po",
        "Tresignana"
    ]],
    ["VV", [
        "Acquaro",
        "Arena",
        "Briatico",
        "Brognaturo",
        "Capistrano",
        "Cessaniti",
        "Dasà",
        "Dinami",
        "Drapia",
        "Fabrizia",
        "Filadelfia",
        "Filandari",
        "Filogaso",
        "Francavilla Angitola",
        "Francica",
        "Gerocarne",
        "Ionadi",
        "Joppolo",
        "Limbadi",
        "Maierato",
        "Mileto",
        "Mongiana",
        "Monterosso Calabro",
        "Nardodipace",
        "Nicotera",
        "Parghelia",
        "Pizzo",
        "Pizzoni",
        "Polia",
        "Ricadi",
        "Rombiolo",
        "San Calogero",
        "San Costantino Calabro",
        "San Gregorio d\u0027Ippona",
        "San Nicola da Crissa",
        "Sant\u0027Onofrio",
        "Serra San Bruno",
        "Simbario",
        "Sorianello",
        "Soriano Calabro",
        "Spadola",
        "Spilinga",
        "Stefanaconi",
        "Tropea",
        "Vallelonga",
        "Vazzano",
        "Vibo Valentia",
        "Zaccanopoli",
        "Zambrone",
        "Zungri"
    ]],
    ["FG", [
        "Accadia",
        "Alberona",
        "Anzano di Puglia",
        "Apricena",
        "Ascoli Satriano",
        "Biccari",
        "Bovino",
        "Cagnano Varano",
        "Candela",
        "Carapelle",
        "Carlantino",
        "Carpino",
        "Casalnuovo Monterotaro",
        "Casalvecchio di Puglia",
        "Castelluccio dei Sauri",
        "Castelluccio Valmaggiore",
        "Castelnuovo della Daunia",
        "Celenza Valfortore",
        "Celle di San Vito",
        "Cerignola",
        "Chieuti",
        "Deliceto",
        "Faeto",
        "Foggia",
        "Ischitella",
        "Isole Tremiti",
        "Lesina",
        "Lucera",
        "Manfredonia",
        "Mattinata",
        "Monteleone di Puglia",
        "Monte Sant\u0027Angelo",
        "Motta Montecorvino",
        "Orsara di Puglia",
        "Orta Nova",
        "Panni",
        "Peschici",
        "Pietramontecorvino",
        "Poggio Imperiale",
        "Rignano Garganico",
        "Rocchetta Sant\u0027Antonio",
        "Rodi Garganico",
        "Roseto Valfortore",
        "San Giovanni Rotondo",
        "San Marco in Lamis",
        "San Marco la Catola",
        "San Nicandro Garganico",
        "San Paolo di Civitate",
        "San Severo",
        "Sant\u0027Agata di Puglia",
        "Serracapriola",
        "Stornara",
        "Stornarella",
        "Torremaggiore",
        "Troia",
        "Vico del Gargano",
        "Vieste",
        "Volturara Appula",
        "Volturino",
        "Ordona",
        "Zapponeta"
    ]],
    ["NO", [
        "Agrate Conturbia",
        "Ameno",
        "Armeno",
        "Arona",
        "Barengo",
        "Bellinzago Novarese",
        "Biandrate",
        "Boca",
        "Bogogno",
        "Bolzano Novarese",
        "Borgolavezzaro",
        "Borgomanero",
        "Borgo Ticino",
        "Briga Novarese",
        "Briona",
        "Caltignaga",
        "Cameri",
        "Carpignano Sesia",
        "Casalbeltrame",
        "Casaleggio Novara",
        "Casalino",
        "Casalvolone",
        "Castellazzo Novarese",
        "Castelletto sopra Ticino",
        "Cavaglietto",
        "Cavaglio d\u0027Agogna",
        "Cavallirio",
        "Cerano",
        "Colazza",
        "Comignago",
        "Cressa",
        "Cureggio",
        "Divignano",
        "Dormelletto",
        "Fara Novarese",
        "Fontaneto d\u0027Agogna",
        "Galliate",
        "Garbagna Novarese",
        "Gargallo",
        "Ghemme",
        "Gozzano",
        "Granozzo con Monticello",
        "Grignasco",
        "Invorio",
        "Landiona",
        "Lesa",
        "Maggiora",
        "Mandello Vitta",
        "Marano Ticino",
        "Massino Visconti",
        "Meina",
        "Mezzomerico",
        "Miasino",
        "Momo",
        "Nebbiuno",
        "Nibbiola",
        "Novara",
        "Oleggio",
        "Oleggio Castello",
        "Orta San Giulio",
        "Paruzzaro",
        "Pella",
        "Pettenasco",
        "Pisano",
        "Pogno",
        "Pombia",
        "Prato Sesia",
        "Recetto",
        "Romagnano Sesia",
        "Romentino",
        "San Maurizio d\u0027Opaglio",
        "San Nazzaro Sesia",
        "San Pietro Mosezzo",
        "Sillavengo",
        "Sizzano",
        "Soriso",
        "Sozzago",
        "Suno",
        "Terdobbiate",
        "Tornaco",
        "Trecate",
        "Vaprio d\u0027Agogna",
        "Varallo Pombia",
        "Vespolate",
        "Vicolungo",
        "Vinzaglio",
        "Gattico-Veruno"
    ]],
    ["FI", [
        "Bagno a Ripoli",
        "Barberino di Mugello",
        "Borgo San Lorenzo",
        "Calenzano",
        "Campi Bisenzio",
        "Capraia e Limite",
        "Castelfiorentino",
        "Cerreto Guidi",
        "Certaldo",
        "Dicomano",
        "Empoli",
        "Fiesole",
        "Firenze",
        "Firenzuola",
        "Fucecchio",
        "Gambassi Terme",
        "Greve in Chianti",
        "Impruneta",
        "Lastra a Signa",
        "Londa",
        "Marradi",
        "Montaione",
        "Montelupo Fiorentino",
        "Montespertoli",
        "Palazzuolo sul Senio",
        "Pelago",
        "Pontassieve",
        "Reggello",
        "Rignano sull\u0027Arno",
        "Rufina",
        "San Casciano in Val di Pesa",
        "San Godenzo",
        "Scandicci",
        "Sesto Fiorentino",
        "Signa",
        "Vaglia",
        "Vicchio",
        "Vinci",
        "Figline e Incisa Valdarno",
        "Scarperia e San Piero",
        "Barberino Tavarnelle"
    ]],
    ["NU", [
        "Aritzo",
        "Arzana",
        "Atzara",
        "Austis",
        "Bari Sardo",
        "Baunei",
        "Belvì",
        "Birori",
        "Bitti",
        "Bolotana",
        "Borore",
        "Bortigali",
        "Desulo",
        "Dorgali",
        "Dualchi",
        "Elini",
        "Fonni",
        "Gadoni",
        "Gairo",
        "Galtellì",
        "Gavoi",
        "Girasole",
        "Ilbono",
        "Irgoli",
        "Jerzu",
        "Lanusei",
        "Lei",
        "Loceri",
        "Loculi",
        "Lodè",
        "Lotzorai",
        "Lula",
        "Macomer",
        "Mamoiada",
        "Meana Sardo",
        "Noragugume",
        "Nuoro",
        "Oliena",
        "Ollolai",
        "Olzai",
        "Onanì",
        "Onifai",
        "Oniferi",
        "Orani",
        "Orgosolo",
        "Orosei",
        "Orotelli",
        "Ortueri",
        "Orune",
        "Osidda",
        "Osini",
        "Ottana",
        "Ovodda",
        "Perdasdefogu",
        "Posada",
        "Sarule",
        "Silanus",
        "Sindia",
        "Siniscola",
        "Sorgono",
        "Talana",
        "Tertenia",
        "Teti",
        "Tiana",
        "Tonara",
        "Torpè",
        "Tortolì",
        "Triei",
        "Ulassai",
        "Urzulei",
        "Ussassai",
        "Villagrande Strisaili",
        "Cardedu",
        "Lodine"
    ]],
    ["FM", [
        "Altidona",
        "Amandola",
        "Belmonte Piceno",
        "Campofilone",
        "Falerone",
        "Fermo",
        "Francavilla d\u0027Ete",
        "Grottazzolina",
        "Lapedona",
        "Magliano di Tenna",
        "Massa Fermana",
        "Monsampietro Morico",
        "Montappone",
        "Montefalcone Appennino",
        "Montefortino",
        "Monte Giberto",
        "Montegiorgio",
        "Montegranaro",
        "Monteleone di Fermo",
        "Montelparo",
        "Monte Rinaldo",
        "Monterubbiano",
        "Monte San Pietrangeli",
        "Monte Urano",
        "Monte Vidon Combatte",
        "Monte Vidon Corrado",
        "Montottone",
        "Moresco",
        "Ortezzano",
        "Pedaso",
        "Petritoli",
        "Ponzano di Fermo",
        "Porto San Giorgio",
        "Porto Sant\u0027Elpidio",
        "Rapagnano",
        "Santa Vittoria in Matenano",
        "Sant\u0027Elpidio a Mare",
        "Servigliano",
        "Smerillo",
        "Torre San Patrizio"
    ]],
    ["FR", [
        "Acquafondata",
        "Acuto",
        "Alatri",
        "Alvito",
        "Amaseno",
        "Anagni",
        "Aquino",
        "Arce",
        "Arnara",
        "Arpino",
        "Atina",
        "Ausonia",
        "Belmonte Castello",
        "Boville Ernica",
        "Broccostella",
        "Campoli Appennino",
        "Casalattico",
        "Casalvieri",
        "Cassino",
        "Castelliri",
        "Castelnuovo Parano",
        "Castrocielo",
        "Castro dei Volsci",
        "Ceccano",
        "Ceprano",
        "Cervaro",
        "Colfelice",
        "Collepardo",
        "Colle San Magno",
        "Coreno Ausonio",
        "Esperia",
        "Falvaterra",
        "Ferentino",
        "Filettino",
        "Fiuggi",
        "Fontana Liri",
        "Fontechiari",
        "Frosinone",
        "Fumone",
        "Gallinaro",
        "Giuliano di Roma",
        "Guarcino",
        "Isola del Liri",
        "Monte San Giovanni Campano",
        "Morolo",
        "Paliano",
        "Pastena",
        "Patrica",
        "Pescosolido",
        "Picinisco",
        "Pico",
        "Piedimonte San Germano",
        "Piglio",
        "Pignataro Interamna",
        "Pofi",
        "Pontecorvo",
        "Posta Fibreno",
        "Ripi",
        "Rocca d\u0027Arce",
        "Roccasecca",
        "San Biagio Saracinisco",
        "San Donato Val di Comino",
        "San Giorgio a Liri",
        "San Giovanni Incarico",
        "Sant\u0027Ambrogio sul Garigliano",
        "Sant\u0027Andrea del Garigliano",
        "Sant\u0027Apollinare",
        "Sant\u0027Elia Fiumerapido",
        "Santopadre",
        "San Vittore del Lazio",
        "Serrone",
        "Settefrati",
        "Sgurgola",
        "Sora",
        "Strangolagalli",
        "Supino",
        "Terelle",
        "Torre Cajetani",
        "Torrice",
        "Trevi nel Lazio",
        "Trivigliano",
        "Vallecorsa",
        "Vallemaio",
        "Vallerotonda",
        "Veroli",
        "Vicalvi",
        "Vico nel Lazio",
        "Villa Latina",
        "Villa Santa Lucia",
        "Villa Santo Stefano",
        "Viticuso"
    ]],
    ["GE", [
        "Arenzano",
        "Avegno",
        "Bargagli",
        "Bogliasco",
        "Borzonasca",
        "Busalla",
        "Camogli",
        "Campo Ligure",
        "Campomorone",
        "Carasco",
        "Casarza Ligure",
        "Casella",
        "Castiglione Chiavarese",
        "Ceranesi",
        "Chiavari",
        "Cicagna",
        "Cogoleto",
        "Cogorno",
        "Coreglia Ligure",
        "Crocefieschi",
        "Davagna",
        "Fascia",
        "Favale di Malvaro",
        "Fontanigorda",
        "Genova",
        "Gorreto",
        "Isola del Cantone",
        "Lavagna",
        "Leivi",
        "Lorsica",
        "Lumarzo",
        "Masone",
        "Mele",
        "Mezzanego",
        "Mignanego",
        "Moconesi",
        "Moneglia",
        "Montebruno",
        "Montoggio",
        "Ne",
        "Neirone",
        "Orero",
        "Pieve Ligure",
        "Portofino",
        "Propata",
        "Rapallo",
        "Recco",
        "Rezzoaglio",
        "Ronco Scrivia",
        "Rondanina",
        "Rossiglione",
        "Rovegno",
        "San Colombano Certenoli",
        "Santa Margherita Ligure",
        "Sant\u0027Olcese",
        "Santo Stefano d\u0027Aveto",
        "Savignone",
        "Serra Riccò",
        "Sestri Levante",
        "Sori",
        "Tiglieto",
        "Torriglia",
        "Tribogna",
        "Uscio",
        "Valbrevenna",
        "Vobbia",
        "Zoagli"
    ]],
    ["OR", [
        "Abbasanta",
        "Aidomaggiore",
        "Albagiara",
        "Ales",
        "Allai",
        "Arborea",
        "Ardauli",
        "Assolo",
        "Asuni",
        "Baradili",
        "Baratili San Pietro",
        "Baressa",
        "Bauladu",
        "Bidonì",
        "Bonarcado",
        "Boroneddu",
        "Busachi",
        "Cabras",
        "Cuglieri",
        "Fordongianus",
        "Ghilarza",
        "Gonnoscodina",
        "Gonnosnò",
        "Gonnostramatza",
        "Marrubiu",
        "Masullas",
        "Milis",
        "Mogorella",
        "Mogoro",
        "Morgongiori",
        "Narbolia",
        "Neoneli",
        "Norbello",
        "Nughedu Santa Vittoria",
        "Nurachi",
        "Nureci",
        "Ollastra",
        "Oristano",
        "Palmas Arborea",
        "Pau",
        "Paulilatino",
        "Pompu",
        "Riola Sardo",
        "Ruinas",
        "Samugheo",
        "San Nicolò d\u0027Arcidano",
        "Santa Giusta",
        "Villa Sant\u0027Antonio",
        "Santu Lussurgiu",
        "San Vero Milis",
        "Scano di Montiferro",
        "Sedilo",
        "Seneghe",
        "Senis",
        "Sennariolo",
        "Siamaggiore",
        "Siamanna",
        "Simala",
        "Simaxis",
        "Sini",
        "Siris",
        "Solarussa",
        "Sorradile",
        "Tadasuni",
        "Terralba",
        "Tramatza",
        "Tresnuraghes",
        "Ulà Tirso",
        "Uras",
        "Usellus",
        "Villanova Truschedu",
        "Villaurbana",
        "Villa Verde",
        "Zeddiani",
        "Zerfaliu",
        "Siapiccia",
        "Curcuris",
        "Soddì",
        "Bosa",
        "Flussio",
        "Laconi",
        "Magomadas",
        "Modolo",
        "Montresta",
        "Sagama",
        "Suni",
        "Tinnura"
    ]],
    ["GO", [
        "Capriva del Friuli",
        "Cormons",
        "Doberdò del Lago",
        "Dolegna del Collio",
        "Farra d\u0027Isonzo",
        "Fogliano Redipuglia",
        "Gorizia",
        "Gradisca d\u0027Isonzo",
        "Grado",
        "Mariano del Friuli",
        "Medea",
        "Monfalcone",
        "Moraro",
        "Mossa",
        "Romans d\u0027Isonzo",
        "Ronchi dei Legionari",
        "Sagrado",
        "San Canzian d\u0027Isonzo",
        "San Floriano del Collio",
        "San Lorenzo Isontino",
        "San Pier d\u0027Isonzo",
        "Savogna d\u0027Isonzo",
        "Staranzano",
        "Turriaco",
        "Villesse"
    ]],
    ["GR", [
        "Arcidosso",
        "Campagnatico",
        "Capalbio",
        "Castel del Piano",
        "Castell\u0027Azzara",
        "Castiglione della Pescaia",
        "Cinigiano",
        "Civitella Paganico",
        "Follonica",
        "Gavorrano",
        "Grosseto",
        "Isola del Giglio",
        "Magliano in Toscana",
        "Manciano",
        "Massa Marittima",
        "Monte Argentario",
        "Montieri",
        "Orbetello",
        "Pitigliano",
        "Roccalbegna",
        "Roccastrada",
        "Santa Fiora",
        "Scansano",
        "Scarlino",
        "Seggiano",
        "Sorano",
        "Monterotondo Marittimo",
        "Semproniano"
    ]],
    ["PA", [
        "Alia",
        "Alimena",
        "Aliminusa",
        "Altavilla Milicia",
        "Altofonte",
        "Bagheria",
        "Balestrate",
        "Baucina",
        "Belmonte Mezzagno",
        "Bisacquino",
        "Bolognetta",
        "Bompietro",
        "Borgetto",
        "Caccamo",
        "Caltavuturo",
        "Campofelice di Fitalia",
        "Campofelice di Roccella",
        "Campofiorito",
        "Camporeale",
        "Capaci",
        "Carini",
        "Castelbuono",
        "Casteldaccia",
        "Castellana Sicula",
        "Castronovo di Sicilia",
        "Cefalà Diana",
        "Cefalù",
        "Cerda",
        "Chiusa Sclafani",
        "Ciminna",
        "Cinisi",
        "Collesano",
        "Contessa Entellina",
        "Corleone",
        "Ficarazzi",
        "Gangi",
        "Geraci Siculo",
        "Giardinello",
        "Giuliana",
        "Godrano",
        "Gratteri",
        "Isnello",
        "Isola delle Femmine",
        "Lascari",
        "Lercara Friddi",
        "Marineo",
        "Mezzojuso",
        "Misilmeri",
        "Monreale",
        "Montelepre",
        "Montemaggiore Belsito",
        "Palazzo Adriano",
        "Palermo",
        "Partinico",
        "Petralia Soprana",
        "Petralia Sottana",
        "Piana degli Albanesi",
        "Polizzi Generosa",
        "Pollina",
        "Prizzi",
        "Roccamena",
        "Roccapalumba",
        "San Cipirello",
        "San Giuseppe Jato",
        "San Mauro Castelverde",
        "Santa Cristina Gela",
        "Santa Flavia",
        "Sciara",
        "Sclafani Bagni",
        "Termini Imerese",
        "Terrasini",
        "Torretta",
        "Trabia",
        "Trappeto",
        "Ustica",
        "Valledolmo",
        "Ventimiglia di Sicilia",
        "Vicari",
        "Villabate",
        "Villafrati",
        "Scillato",
        "Blufi"
    ]],
    ["PC", [
        "Agazzano",
        "Alseno",
        "Besenzone",
        "Bettola",
        "Bobbio",
        "Borgonovo Val Tidone",
        "Cadeo",
        "Calendasco",
        "Caorso",
        "Carpaneto Piacentino",
        "Castell\u0027Arquato",
        "Castel San Giovanni",
        "Castelvetro Piacentino",
        "Cerignale",
        "Coli",
        "Corte Brugnatella",
        "Cortemaggiore",
        "Farini",
        "Ferriere",
        "Fiorenzuola d\u0027Arda",
        "Gazzola",
        "Gossolengo",
        "Gragnano Trebbiense",
        "Gropparello",
        "Lugagnano Val d\u0027Arda",
        "Monticelli d\u0027Ongina",
        "Morfasso",
        "Ottone",
        "Piacenza",
        "Pianello Val Tidone",
        "Piozzano",
        "Podenzano",
        "Ponte dell\u0027Olio",
        "Pontenure",
        "Rivergaro",
        "Rottofreno",
        "San Giorgio Piacentino",
        "San Pietro in Cerro",
        "Sarmato",
        "Travo",
        "Vernasca",
        "Vigolzone",
        "Villanova sull\u0027Arda",
        "Zerba",
        "Ziano Piacentino",
        "Alta Val Tidone"
    ]],
    ["PD", [
        "Abano Terme",
        "Agna",
        "Albignasego",
        "Anguillara Veneta",
        "Arquà Petrarca",
        "Arre",
        "Arzergrande",
        "Bagnoli di Sopra",
        "Baone",
        "Barbona",
        "Battaglia Terme",
        "Boara Pisani",
        "Borgoricco",
        "Bovolenta",
        "Brugine",
        "Cadoneghe",
        "Campodarsego",
        "Campodoro",
        "Camposampiero",
        "Campo San Martino",
        "Candiana",
        "Carmignano di Brenta",
        "Cartura",
        "Casale di Scodosia",
        "Casalserugo",
        "Castelbaldo",
        "Cervarese Santa Croce",
        "Cinto Euganeo",
        "Cittadella",
        "Codevigo",
        "Conselve",
        "Correzzola",
        "Curtarolo",
        "Este",
        "Fontaniva",
        "Galliera Veneta",
        "Galzignano Terme",
        "Gazzo",
        "Grantorto",
        "Granze",
        "Legnaro",
        "Limena",
        "Loreggia",
        "Lozzo Atestino",
        "Maserà di Padova",
        "Masi",
        "Massanzago",
        "Megliadino San Vitale",
        "Merlara",
        "Mestrino",
        "Monselice",
        "Montagnana",
        "Montegrotto Terme",
        "Noventa Padovana",
        "Ospedaletto Euganeo",
        "Padova",
        "Pernumia",
        "Piacenza d\u0027Adige",
        "Piazzola sul Brenta",
        "Piombino Dese",
        "Piove di Sacco",
        "Polverara",
        "Ponso",
        "Pontelongo",
        "Ponte San Nicolò",
        "Pozzonovo",
        "Rovolon",
        "Rubano",
        "Saccolongo",
        "San Giorgio delle Pertiche",
        "San Giorgio in Bosco",
        "San Martino di Lupari",
        "San Pietro in Gu",
        "San Pietro Viminario",
        "Santa Giustina in Colle",
        "Sant\u0027Angelo di Piove di Sacco",
        "Sant\u0027Elena",
        "Sant\u0027Urbano",
        "Saonara",
        "Selvazzano Dentro",
        "Solesino",
        "Stanghella",
        "Teolo",
        "Terrassa Padovana",
        "Tombolo",
        "Torreglia",
        "Trebaseleghe",
        "Tribano",
        "Urbana",
        "Veggiano",
        "Vescovana",
        "Vigodarzere",
        "Vigonza",
        "Villa del Conte",
        "Villa Estense",
        "Villafranca Padovana",
        "Villanova di Camposampiero",
        "Vo\u0027",
        "Due Carrare",
        "Borgo Veneto",
        "Santa Caterina d\u0027Este"
    ]],
    ["PE", [
        "Abbateggio",
        "Alanno",
        "Bolognano",
        "Brittoli",
        "Bussi sul Tirino",
        "Cappelle sul Tavo",
        "Caramanico Terme",
        "Carpineto della Nora",
        "Castiglione a Casauria",
        "Catignano",
        "Cepagatti",
        "Città Sant\u0027Angelo",
        "Civitaquana",
        "Civitella Casanova",
        "Collecorvino",
        "Corvara",
        "Cugnoli",
        "Elice",
        "Farindola",
        "Lettomanoppello",
        "Loreto Aprutino",
        "Manoppello",
        "Montebello di Bertona",
        "Montesilvano",
        "Moscufo",
        "Nocciano",
        "Penne",
        "Pescara",
        "Pescosansonesco",
        "Pianella",
        "Picciano",
        "Pietranico",
        "Popoli Terme",
        "Roccamorice",
        "Rosciano",
        "Salle",
        "Sant\u0027Eufemia a Maiella",
        "San Valentino in Abruzzo Citeriore",
        "Scafa",
        "Serramonacesca",
        "Spoltore",
        "Tocco da Casauria",
        "Torre de\u0027 Passeri",
        "Turrivalignani",
        "Vicoli",
        "Villa Celiera"
    ]],
    ["PG", [
        "Assisi",
        "Bastia Umbra",
        "Bettona",
        "Bevagna",
        "Campello sul Clitunno",
        "Cannara",
        "Cascia",
        "Castel Ritaldi",
        "Castiglione del Lago",
        "Cerreto di Spoleto",
        "Citerna",
        "Città della Pieve",
        "Città di Castello",
        "Collazzone",
        "Corciano",
        "Costacciaro",
        "Deruta",
        "Foligno",
        "Fossato di Vico",
        "Fratta Todina",
        "Giano dell\u0027Umbria",
        "Gualdo Cattaneo",
        "Gualdo Tadino",
        "Gubbio",
        "Lisciano Niccone",
        "Magione",
        "Marsciano",
        "Massa Martana",
        "Monte Castello di Vibio",
        "Montefalco",
        "Monteleone di Spoleto",
        "Monte Santa Maria Tiberina",
        "Montone",
        "Nocera Umbra",
        "Norcia",
        "Paciano",
        "Panicale",
        "Passignano sul Trasimeno",
        "Perugia",
        "Piegaro",
        "Pietralunga",
        "Poggiodomo",
        "Preci",
        "San Giustino",
        "Sant\u0027Anatolia di Narco",
        "Scheggia e Pascelupo",
        "Scheggino",
        "Sellano",
        "Sigillo",
        "Spello",
        "Spoleto",
        "Todi",
        "Torgiano",
        "Trevi",
        "Tuoro sul Trasimeno",
        "Umbertide",
        "Valfabbrica",
        "Vallo di Nera",
        "Valtopina"
    ]],
    ["PI", [
        "Bientina",
        "Buti",
        "Calci",
        "Calcinaia",
        "Capannoli",
        "Casale Marittimo",
        "Cascina",
        "Castelfranco di Sotto",
        "Castellina Marittima",
        "Castelnuovo di Val di Cecina",
        "Chianni",
        "Fauglia",
        "Guardistallo",
        "Lajatico",
        "Montecatini Val di Cecina",
        "Montescudaio",
        "Monteverdi Marittimo",
        "Montopoli in Val d\u0027Arno",
        "Orciano Pisano",
        "Palaia",
        "Peccioli",
        "Pisa",
        "Pomarance",
        "Ponsacco",
        "Pontedera",
        "Riparbella",
        "San Giuliano Terme",
        "San Miniato",
        "Santa Croce sull\u0027Arno",
        "Santa Luce",
        "Santa Maria a Monte",
        "Terricciola",
        "Vecchiano",
        "Vicopisano",
        "Volterra",
        "Casciana Terme Lari",
        "Crespina Lorenzana"
    ]],
    ["PN", [
        "Andreis",
        "Arba",
        "Aviano",
        "Azzano Decimo",
        "Barcis",
        "Brugnera",
        "Budoia",
        "Caneva",
        "Casarsa della Delizia",
        "Castelnovo del Friuli",
        "Cavasso Nuovo",
        "Chions",
        "Cimolais",
        "Claut",
        "Clauzetto",
        "Cordenons",
        "Cordovado",
        "Erto e Casso",
        "Fanna",
        "Fiume Veneto",
        "Fontanafredda",
        "Frisanco",
        "Maniago",
        "Meduno",
        "Montereale Valcellina",
        "Morsano al Tagliamento",
        "Pasiano di Pordenone",
        "Pinzano al Tagliamento",
        "Polcenigo",
        "Porcia",
        "Pordenone",
        "Prata di Pordenone",
        "Pravisdomini",
        "Roveredo in Piano",
        "Sacile",
        "San Giorgio della Richinvelda",
        "San Martino al Tagliamento",
        "San Quirino",
        "San Vito al Tagliamento",
        "Sequals",
        "Sesto al Reghena",
        "Spilimbergo",
        "Tramonti di Sopra",
        "Tramonti di Sotto",
        "Travesio",
        "Vito d\u0027Asio",
        "Vivaro",
        "Zoppola",
        "Vajont",
        "Valvasone Arzene"
    ]],
    ["PO", [
        "Cantagallo",
        "Carmignano",
        "Montemurlo",
        "Poggio a Caiano",
        "Prato",
        "Vaiano",
        "Vernio"
    ]]
])